import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Icon, Loader ,Popup, Checkbox, Button, Modal, Dropdown } from 'semantic-ui-react'
import { createMerchandiseDutyItem } from '../../api/createItem'
import {get} from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { connect } from 'react-redux'
import SelecTextField from '../../formComponents/selectTextField'
import InputField from '../../formComponents/inputField'
import Warning from '../Warnings/Warning'
import * as actionCreators from '../../actions'
import HTSCodePopup from '../../HTSWidget/HTSCodePopup'
import { getPopUpIcon } from '../util'
import { deletePgaFormData, deleteAdCvdFormData } from '../../api/deleteFormData'
import { DutyItemFields } from '../../util/supportedFields/descriptionOfMerchandise'
import { resetDutyItemFieldsInNonCommodity} from "../../util";
import PopUpIcon from '../../formComponents/PopUpIcon'
import { isEmpty } from 'lodash'
import { getHSDtlList, deleteUnusedPGAS } from "../../api/htsRequests"; 
import { formatHTS, chinaExlcusionHTSTriggers } from "../../../CBP_App/util";
import CopyToClipboard from "../../../commonComponents/copyToClipboard"
import { QryFuncModal } from "kx-common-components";
import _ from 'lodash'
import { aluminiumMeltAndPour, getExclusionHTSES, russiaMetaData, steelAndAluminiumHts, steelMeltAndPourHTSBeginnings, subExclusionHTSES } from '../util/constants';
import { ch82SetHtses, hasanyvaluesAdcvd, isWarehouseEntry, propsAreEqual_NoRerenderNeeded } from '../../reducer/util';
import { HttpPostRequest } from '../../api/setFormData';
import UpdateTariffs from '../UpdateTariffs';
import AdditionDeductionMechLevel from '../AdditionDeduction/AdditionDeductionMechLevel';


export const changeEnteredValueDutyLevel = (value,
  lineItemIndex,
  invoiceItemIndex,
  index, thisprops,allDuties, saveafterwards,actualField,callback)=>{
  let { shipmentId } = thisprops;
  if(thisprops.launchFrom === 'PRODUCT_HISTORY'){
    return;
  }
  // Only perform changes if the field was touched (value was edited)
  thisprops.updateMerchDutyItemFeild(
    invoiceItemIndex,
    lineItemIndex,
    index,
    "enteredValue",
    parseFloat(value || 0).toFixed(2)
  );

  thisprops.handleDutyItemContextSwitch(
    lineItemIndex,
    invoiceItemIndex,
    index
  );
  // action for updating invoice amount

  // Update Tital Value
  thisprops.updateTotalValueAndGrossWeight();
  
  if(saveafterwards){

    
    let saveCall = thisprops.saveMerchDutyItem(
      lineItemIndex,
      invoiceItemIndex,
      index,
      "enteredValue",
      value,
      "",
      callback,
      actualField,
    );

    allDuties.forEach((item, dutyIndex) => {
      setTimeout(()=>{
        if (item.isCommodityDuty != 1) {
          thisprops.saveMerchDutyItem(
            lineItemIndex,
            invoiceItemIndex,
            dutyIndex,
            "dutyRate"
          );
        }
      },dutyIndex*1000)
    });
    setTimeout(()=>{
      if(localStorage.getItem("disableAutoCalculate") == 'true'){

      }else {
        document.getElementById(`recalculateLineItemWeights${shipmentId}`) && document.getElementById(`recalculateLineItemWeights${shipmentId}`).click();
      }
    },2500)
    return saveCall;
  }
  return new Promise((resolve, reject) => {
      resolve({});
    });
}

export const saveWholeInvoiceEnteredValue = (thisprops,invoiceItemIndex,shipmentId) =>{
  
  for(let iiii of [1]){
    setTimeout(() => {
      thisprops.saveWholeInvoice(
        invoiceItemIndex,
        ["htsus","enteredValue","isCommodityDuty","dutyRate"]
      );
    }, 400*iiii);
  }
  setTimeout(()=>{
    if(localStorage.getItem("disableAutoCalculate") == 'true'){

    }else {
      let recalcButton = document.getElementById(`recalculateLineItemWeights${shipmentId}`);
      if(recalcButton && ((recalcButton.getAttribute("lastClickCCCC")||0)<Date.now()-1000)){
        
        recalcButton.setAttribute("lastClickCCCC",Date.now());
        recalcButton.click();
      } 
    }
  },1500)
}

export const hasanyoverrideflag = (allDuties) =>{
  if(!allDuties)return false;
  for(let oneduty of allDuties){
    if(oneduty.dutyOverrideFlag == 1){
      return true;
    }
  }
  return false
}

export const hasDutyOverride = (oneduty, merchandiseDuties) => {
  let hasAnyNinetyEightDuty = false;
  for (let onedutyXX of merchandiseDuties||[]) {
    if (onedutyXX && onedutyXX.htsus) {
      if (onedutyXX.htsus.slice(0, 2) == "98") hasAnyNinetyEightDuty = true;
      if (onedutyXX.htsus.slice(0, 4) == "9802") hasAnyNinetyEightDuty = false;
      if (onedutyXX.htsus.replace(/\./g, "")  =="99039008") hasAnyNinetyEightDuty = true;
    }
  }
  let htsChapter = parseInt((oneduty.htsus || "")?.slice(0, 2))
  const isNinetyNineDuty = htsChapter == "99"

  let isCommodityHTS = htsChapter !== 98 && htsChapter !== 99;
  let isCommodityDutyBoolean = oneduty.isCommodityDuty === 1;

  return (isNinetyNineDuty || isCommodityDutyBoolean) && hasAnyNinetyEightDuty;
}

class DutyItem extends React.Component {

  
  constructor(props) {
    super(props)
    this.state = {
      formInfo: {},
      expanded: true,
      isDeletingHTS: false,
      hts: props?.htsus?.replace(/\./g, '')||"",
      showhtspopup: false,
      htsError: 200 ,
      htsHasBeenLengthZero: !(props?.htsus?.replace(/\./g, '')||"")?.length,
      isUnitPriceUpdating:false,
      isINVQtyUpdating:false,
      previousEnteredValue: false
    }
    for (let key in DutyItemFields) {
      DutyItemFields[key].errors = []
      DutyItemFields[key].valid = []
    }
    this.addErrorClass.bind(this)
    this.removeErrorClass.bind(this)
    this.validateField.bind(this)
    this.getValidationBasedOnHts.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState){
    if(window.slowstate)return true;

    return this.state.showhtspopup || !propsAreEqual_NoRerenderNeeded(this.state,nextState) || !propsAreEqual_NoRerenderNeeded(this.props,nextProps);

  }


  getDutyRate(data) {
    let dutyRateStr = [];
    if(data.specificRate && data.specificRate!=0 && data.specificRate!='_BLANK_' && data.manifestQuantityUnits){
      dutyRateStr.push(data.specificRate+" cents per "+(data?.hsDataDtl?.unit1 || data.manifestQuantityUnits)+", ");
    }
    if(data.otherRate && data.otherRate!=0 && data.otherRate!='_BLANK_' && data.additionalQuantityUnits){
      dutyRateStr.push(data.otherRate+" cents per "+(data?.hsDataDtl?.unit2 || data.additionalQuantityUnits) + ", ");
    }
    dutyRateStr.push(data.dutyRate+"%");
    return dutyRateStr.join("");
  }
  // Check field Validity
  validateField(lineItemIndex, fieldName, value) {
    // let warning = 0
    const newState = Object.assign({}, this.state)
    newState.formInfo[fieldName] = value
    this.setState(newState)
    DutyItemFields[fieldName].errors = []
    DutyItemFields[fieldName].valid = true
    if (
      DutyItemFields[fieldName].rules &&
      DutyItemFields[fieldName].rules.length > 0
    ) {
      DutyItemFields[fieldName].rules.forEach(rule => {
        //console.log(rule.test(value))
        if (!rule.test(value)) {
          DutyItemFields[fieldName].errors.push(rule.message)
          DutyItemFields[fieldName].valid = false
        }
      })
    }
    // Object.keys(DoMFields).forEach(field => {
    //   if (!DoMFields[field].valid) {
    //     warning++
    //   }
    // })
    // this.props.updateDOMErrorWarning(warning)
    if (DutyItemFields[fieldName].errors.length) {
      this.addErrorClass(lineItemIndex + fieldName, DutyItemFields)
    } else {
      this.removeErrorClass(lineItemIndex + fieldName, DutyItemFields)
    }
  }
  addErrorClass(fieldName, fieldType) {
    const inputField = document.getElementById(fieldName + window.shipmentId)
    if(inputField){
      inputField.classList.add('errorInput')
    }
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId)
      if(inputField){
        inputField.classList.remove('errorInput')
      }
    } catch (e) {
      console.error(e)
    }
  }

  

  deleteOldPGACVDData(newHts,deletePGAData,hsDataDtlParameter) {
    let {
      merchandiseId,
      shipmentId,
      merchandiseDutyId,
      updateMerchLineItemPgaObject,
      updateMerchLineItemFeild,
      isCommodityDuty,
      adcvd,
      lineItemIndex,
      index,
      updateMerchDutyItemFeild,
      pgaFlagInfos, 
      invoiceItemIndex,
      showFrightData, 
      invoiceId,
      htsus,
      htsDescription
    } = this.props
    // this.setState({
    //   hts: newHts
    // })
    
    let programsToSaveIfTheyreThere = [];
    let currentPrograms = get(hsDataDtlParameter,"pgaMetadata.tarriffPgaDetails");
    for(let oneProg of currentPrograms||[]){
      for(let oneDetail of oneProg?.programDetails||[]){
        programsToSaveIfTheyreThere.push(oneDetail.formType);
      }
    }
    let keepx =[];
    let deletex=[];
    let seenx ={};
    for(let oneflag of pgaFlagInfos){
      let added=false;
      for(let programToKeep of programsToSaveIfTheyreThere){
        if(seenx[programToKeep])continue;
        if((oneflag.pgaType || oneflag.formType) == programToKeep){
          keepx.push(oneflag);
          added=true;
        }
      }
      if(!added){
        deletex.push(oneflag);
      }
    }
    
    console.log('programsToSaveIfTheyreThere: ', programsToSaveIfTheyreThere, keepx,deletex);
      
    
    if (deletePGAData) {
      deleteUnusedPGAS(keepx,deletex,  merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex,
        updateMerchLineItemPgaObject,updateMerchLineItemFeild, true) 
      // updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "selectedFormTypes", keepx.map(a=>a.pgaType))
      // updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "pgaFlagInfos", keepx)



      if (isCommodityDuty == 1 && (hasanyvaluesAdcvd(adcvd,"ad") || hasanyvaluesAdcvd(adcvd,"cvd"))) {
        let shipId = this.props.pscData.pscShipmentId || shipmentId;
        deleteAdCvdFormData(merchandiseId, merchandiseDutyId, shipId, invoiceId);
        updateMerchDutyItemFeild(invoiceItemIndex, lineItemIndex, index, 'adcvd', {})
      }
    }
    
  }

  componentDidMount() {
    let {
      index,
      lineItemIndex,
      isCommodityDuty,
      setHSDTL,
      htsus,
      invoiceItemIndex ,
      countryOfOrigin,
      currentMerchandiseDuty,
      itDate,
      entryDate,
      isDisabled,
      isBrokerKnAdmin,
    } = this.props
    if(!htsus){
      htsus = this.props.hts || "";
    }
    let createdJustNow = currentMerchandiseDuty && (currentMerchandiseDuty.whenDutyItemCreated + 5000 > Date.now());
    if(this.props.launchFrom !== 'PRODUCT_HISTORY'&& this.props?.useAggregated !== "true") {
        setHSDTL(
          itDate,
          {mustBeEditable:true, 
            isBrokerKnAdmin: this.props.isBrokerKnAdmin,
            dutyIsEditable: this.props.launchFrom !== "PRODUCT_HISTORY" && !isDisabled("dutyItem"),
             ...this.props.EntryTypeInfo, useAggregated: this.props?.useAggregated},
          htsus,
          invoiceItemIndex,
          lineItemIndex,
          index,
          isCommodityDuty,
          !createdJustNow,
          this.props.invoiceId,
          this.props.merchandiseId,
          countryOfOrigin,
          this.props.merchandiseLineItem,
          ()=>{}
        );
      }
  }

  deleteHtsStatus = () => {
    this.setState({
      isDeletingHTS: false
    })
  }
  
  sethtsError = (val) =>{
    this.setState({"htsError": val})
  }

  displayInvalidHtsError = (value) => {
    this.findhts(value);
  };

  getValidationBasedOnHts=(uom ,qty ,label)=>{;
    let childHasSteelAluminium = false;
    (this.props.dutyItems || []).forEach((item, index)=>{
      if(!index)  return;
      if(steelAndAluminiumHts?.includes(item?.htsus?.replace(/\./g, ""))){
        childHasSteelAluminium = true;
      }
    });
    const baseHts = this.props.merchandiseLineItem?.merchandiseDuties?.[0]?.htsus?.slice(0,2)
    const isBaseUnder98 = parseInt(baseHts) < 98 && parseInt(baseHts) > 0;
    let error = [];
    if(((uom !== "_BLANK_" &&  typeof uom !== "undefined"  ) && (qty==="0.00"||!qty)) && !(isBaseUnder98 && childHasSteelAluminium)){
      error.push(`${label} is required, when unit of measurement is present`)
    }else if((!uom || uom === "_BLANK_" || typeof uom === "undefined") && qty>0){
      // error.push(`unit of measurement is required, when ${label} is present`)
    }

    return error
  
  }

  findhts = async (value) => {
    let hts = formatHTS(value);
    let  countryOfOrigin = this.props.countryOfOrigin
    const response = await getHSDtlList(this.props.itDate, this.props.EntryTypeInfo, hts,countryOfOrigin);
    if (
      response.data.eventMessage.header &&
      response.data.eventMessage.header.code
    ) {
      this.sethtsError(response.data.eventMessage.header.code);
    } else {
      this.sethtsError(200);
    }
  };
  hidehtspopup = () => {
  this.setState({showhtspopup:false})
  };

  getAsOfDate = () => {
    let entryTypeInfoObjx = this.props.EntryTypeInfo||{};
    if(entryTypeInfoObjx.entryType === "02" || entryTypeInfoObjx.entryType === "12"){
      if(entryTypeInfoObjx.entryDate && entryTypeInfoObjx.entryDate.epochs){
        return entryTypeInfoObjx.entryDate.epochs
      }
      else{
        return Date.now()
      }
    }
    else{
      return this.props.itDate ||
        entryTypeInfoObjx?.releaseDate?.epochs ||
        entryTypeInfoObjx?.entryDate?.epochs ||
        Date.now()
      
    }
  }

  handleInvoiceQuantityBlur = async ({
    lineItemIndex,
    invoiceItemIndex,
    index,
    invoiceQuantity,
    invoiceQuantityUnits,
    manifestQuantityUnits,
    additionalQuantityUnits,
    isTarget,
    hasCbpQty2,
  },callback) => {
    const unit1 = this.props?.hsDataDtlForThisDuty?.unit1
    const unit2 = this.props?.hsDataDtlForThisDuty?.unit2
    if(isTarget){
      // Construct payload for quantity conversion request
      const qtyConversion = [{ targetUOM: unit1, quantityType: "CBP_REPORTING_QUANTITY_1" }]
      if(hasCbpQty2){
        qtyConversion.push({ targetUOM: unit2, quantityType: "CBP_REPORTING_QUANTITY_2" })
      }
      const conversionPayload = {
        eventMessage: {
          conversionRequestData: [
            {
              key: this.props.merchandiseId,
              value: {
                productTag: this.props.productTag,
                htsCode: this.props.htsus,
                sourceUOM: invoiceQuantityUnits,
                invoiceQty: invoiceQuantity,
                qtyConversion
              },
            },
          ],
          customerCode: this.props?.EntryTypeInfo?.customerCode,
        },
        eventType: "QTY_AND_VALUE_CONVERSION",
        eventTime: Date.now(),
      };
    
      const response = await HttpPostRequest(conversionPayload);
      const success = response?.data?.eventMessage?.success === "true";
    
      if (success) {
        const conversionData = response?.data?.eventMessage?.conversionRequestData?.[this.props.merchandiseId]?.qtyConversion;
        const [cbpQty1, cbpQty2] = conversionData?.map(item => item?.cbpQty) || [null, null];
        const updateQtyArr = [];

        updateQtyArr.push(["manifestQuantity", (cbpQty1 || invoiceQuantity)]);
        if(hasCbpQty2)
          updateQtyArr.push(["additionalQuantity", (cbpQty2 || invoiceQuantity)]);
        
          // Update converted quantities
          updateQtyArr.forEach(([key, value]) => {
            this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, key, "quantity", value);
          });
    
        // Save entry summary duties
        await HttpPostRequest({
          eventType: "SAVE_ENTRY_SUMMARY_DUTIES",
          eventTime: Date.now(),
          eventMessage: {
            descriptionOfMerchandise: {
              entrySummaryInvoices: [
                {
                  invoiceId: this.props.invoiceId,
                  merchandiseLineItems: [
                    {
                      merchandiseId: this.props.merchandiseId,
                      merchandiseDuties: [
                        {
                          invoiceQuantity: { quantity: invoiceQuantity, units: invoiceQuantityUnits},
                          manifestQuantity: { quantity: cbpQty1 },
                          additionalQuantity: { quantity: hasCbpQty2 ? cbpQty2 : " " },
                          merchandiseDutyId: this.props.merchandiseDutyId,
                          isCommodityDuty: this.props?.isCommodityDuty,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            shipmentId: this.props.shipmentId,
          },
        });
      }
    }
    // Update and save invoice quantity
    const formattedInvoiceQty = parseFloat(invoiceQuantity || 0).toFixed(2);
    this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, "invoiceQuantity", "quantity", formattedInvoiceQty);
    this.props.saveMerchDutyItem(lineItemIndex, invoiceItemIndex, index, "invoiceQuantity","","",callback);
  };
  
  handleInvoiceQuantityUnitBlur = async ({
    lineItemIndex,  
    invoiceItemIndex, 
    index,  
    invoiceQuantity, 
    invoiceQuantityUnits,
    value,
    manifestQuantityUnits,
    additionalQuantityUnits,
    isTarget,
    hasCbpQty2
  })=>{
      if(this.props.launchFrom === 'PRODUCT_HISTORY'){
        invoiceQuantity.units = value;
        this.props.updateFormState("invoiceQuantity.units", invoiceQuantity, "merchandiseDuties.duties", index)
        return;
      }

      if(isTarget){
            // Construct payload for quantity conversion request
      const qtyConversion = [{ targetUOM: manifestQuantityUnits, quantityType: "CBP_REPORTING_QUANTITY_1" }]
      if(hasCbpQty2){
        qtyConversion.push({ targetUOM: additionalQuantityUnits, quantityType: "CBP_REPORTING_QUANTITY_2" })
      }
      const conversionPayload = {
        eventMessage: {
          conversionRequestData: [
            {
              key: this.props.merchandiseId,
              value: {
                productTag: this.props.productTag,
                htsCode: this.props.htsus,
                sourceUOM: value,
                invoiceQty: invoiceQuantity,
                qtyConversion
              },
            },
          ],
          customerCode: this.props?.EntryTypeInfo?.customerCode,
        },
        eventType: "QTY_AND_VALUE_CONVERSION",
        eventTime: Date.now(),
      };
    
      const response = await HttpPostRequest(conversionPayload);
      const success = response?.data?.eventMessage?.success === "true";
    
      if (success) {
        const conversionData = response?.data?.eventMessage?.conversionRequestData?.[this.props.merchandiseId]?.qtyConversion;
        const [cbpQty1, cbpQty2] = conversionData?.map(item => item?.cbpQty) || [null, null];
        const updateQtyArr = [];

        if(cbpQty1) updateQtyArr.push(["manifestQuantity", cbpQty1]);
        if(cbpQty2) updateQtyArr.push(["additionalQuantity", cbpQty2]);
        
          // Update converted quantities
          updateQtyArr.forEach(([key, value]) => {
            this.props.updateMerchDutyItemObject(lineItemIndex, invoiceItemIndex, index, key, "quantity", value);
          });
    
        // Save entry summary duties
        await HttpPostRequest({
          eventType: "SAVE_ENTRY_SUMMARY_DUTIES",
          eventTime: Date.now(),
          eventMessage: {
            descriptionOfMerchandise: {
              entrySummaryInvoices: [
                {
                  invoiceId: this.props.invoiceId,
                  merchandiseLineItems: [
                    {
                      merchandiseId: this.props.merchandiseId,
                      merchandiseDuties: [
                        {
                          invoiceQuantity: { quantity: invoiceQuantity, units: invoiceQuantityUnits},
                          manifestQuantity: { quantity: cbpQty1 },
                          additionalQuantity: { quantity: hasCbpQty2 ? cbpQty2 : " " },
                          merchandiseDutyId: this.props.merchandiseDutyId,
                          isCommodityDuty: this.props?.isCommodityDuty,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            shipmentId: this.props.shipmentId,
          },
        });
      }
    }
      this.props.updateMerchDutyItemObject(
        lineItemIndex,
        invoiceItemIndex,
        index,
        "invoiceQuantity",
        "units",
        value
      );
      document.getElementById("VALIDATE_FORM_BUTTON") &&
        document.getElementById("VALIDATE_FORM_BUTTON").click();
  }

  render() {
    const isTarget =window.location.href.includes("target")
    let {
      index,
      lineItemIndex,
      invoiceItem,
      parentHts,
      indexVal,
      htsus,
      itDate,
      entryDate,
      enteredValueZeroIndex,
      currentEnteredValuex,
      allDuties,
      updateMerchDutyItemFeild,
      updateMerchDutyItemObject,
      saveMerchDutyItem,
      merchandiseId,
      merchandiseDutyId,
      manifestQuantityUnits,
      invoiceQuantityUnits,
      manifestQuantityQuantity,
      invoiceQuantity,
      additionalQuantityUnits,
      additionalQuantityQuantity,
      duty,
      dutyRate,
      dutyRateInfo,
      currentMerchandiseDuty,
      dutyOverrideFlag,
      isCommodityDuty,
      unitList,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      rbCounterID,
      setHSDTL,
      footnote,
      formDisabled,
      htsDescription,
      categoryCode,
      handleDutyItemContextSwitch,
      // updateTotals,
      removeDutyItem,
      updateTotalValueAndGrossWeight,
      isDisabled,
      charges,
      unitPrice,
      fieldValidation,
      updateMerchLineItemFeild,displayErrorForEnteredValue,displayErrorMsgForEnterValue,
      saveDescriptionOfMerchandiseLine , invoiceItemIndex ,showFrightData , adjustedValue,
      adjustedValueZeroIndex,
      articleHeader,
      pscData,
      countryOfOrigin,
      shipmentETA,
      updateLineItemWeightsBasedonTotalValueAndGrossWeight,
      // currencyConvertedValue,
      currencyConversionRate,
      currencyExchangeInfo,
      invoiceCurrencyValue,
      hsDataDtl,
      hsDataDtlForThisDuty,
      saveMerchAdditionDeletion,
      totalAdditions,
      totalDeletions
    } = this.props;    
    currencyExchangeInfo=currencyExchangeInfo||{};
    let invoicehasForeignCurrency = currencyExchangeInfo && currencyExchangeInfo?.fromIsoCurrencyCode != "USD";
    let hasForeignCurrency = currencyExchangeInfo && currencyExchangeInfo?.fromIsoCurrencyCode != "USD";
   const isTotalAdditionDeduction=parseFloat(totalAdditions || 0.0)>0 || parseFloat(totalDeletions || 0.0)>0

    let manifestQuantity = {"quantity": "-999", "unit": "KG"}
    let additionalQuantity = {"quantity": "-999", "unit": "KG"}
    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
      lineItemIndex = get(this.props, "prodHistoryFormData.lineItemIndex", 0);
      let duties = get(this.props, "prodHistoryFormData.merchandiseDuties.duties");
      if(duties){
        htsus = duties[index].htsus;
        if(duties[index].manifestQuantity){
          manifestQuantity.quantity = duties[index].manifestQuantity.quantity
          manifestQuantity.unit = duties[index].manifestQuantity.unit
          manifestQuantityQuantity = manifestQuantity.quantity;
          manifestQuantityUnits = manifestQuantity.unit;
          isCommodityDuty = duties[index].isCommodityDuty;
          additionalQuantity.quantity = duties[index].additionalQuantity.quantity
          additionalQuantity.unit = duties[index].additionalQuantity.unit
          additionalQuantityQuantity = additionalQuantity.quantity;
          additionalQuantityUnits = additionalQuantity.unit;
          charges = duties[index].charges;
          enteredValueZeroIndex = duties[index].enteredValue;
          currentEnteredValuex = duties[index].enteredValue;
          dutyRate = duties[index].dutyRate;
          duty = duties[index].duty;
          unitList = this.props.dropdownValues.unitList;
        }
        categoryCode = duties[index].categoryCode;
        htsDescription = duties[index].htsDescription;
      }
    }
    if(!htsus){
      htsus = this.props.hts || "";
    }
    //console.log("specificRate === ", this.props.specificRate);
  
    let htsChapter = parseInt(htsus?.slice(0, 2))
    let incorrectHTSForCommodity = (isCommodityDuty === 1 && (htsChapter < 1 || htsChapter > 97));
    let incorrectHTSForNonCommodity =  (isCommodityDuty === 2 && htsChapter !== 98 && htsChapter !== 99);
    let is9802Hts = htsus.startsWith("9802") && isCommodityDuty === 2;
    const isSteelAluminiumHts = steelAndAluminiumHts?.includes(htsus?.replace(/\./g, ""));
    let isCommodityHTS = (htsChapter !== 98 && htsChapter !== 99) || is9802Hts;
    let isCommodityDutyBoolean = isCommodityDuty === 1;
    let commodityHTSOrPrimaryCommodity = isCommodityHTS || isCommodityDutyBoolean;
    if(!isCommodityDutyBoolean){//non-commodity duties ignore foreign currency
      hasForeignCurrency = false;
    }
    let hasAnyNinetyEightDuty = false;
    if(allDuties){
      for(let oneduty of allDuties){
        if(oneduty && oneduty.htsus){
          if(oneduty.htsus.slice(0,2) == "98")hasAnyNinetyEightDuty=true;
          if (oneduty.htsus.slice(0, 4) == "9802") hasAnyNinetyEightDuty = false;
          if((oneduty.htsus+"").replace(/\./g, "") =="99039008")hasAnyNinetyEightDuty=true;
        }
      }
    }

    const ch82SetHtsesAsDropdown = ch82SetHtses.map(aaa=>{return({id: aaa,value: aaa, description: aaa})});
    const ch82SetForm = () => {
      const  { allDuties, EntryTypeInfo, countryOfOrigin, itDate, currencyExchangeInfo } = this.props;

      for(let oneLine of (this.state.ch82BuilderHash || []) ) {
        if(!oneLine.htsus)continue;
        if(this.state[`metadataGathered${oneLine.htsus.replaceAll(".","")}`])continue;
        if(!((oneLine.htsus||"").replaceAll(".","").length == 8 || (oneLine.htsus||"").replaceAll(".","").length == 10))continue;
        getHSDtlList(itDate, EntryTypeInfo, oneLine.htsus,countryOfOrigin).then(newMetaData=>{
          this.setState({[`metadataGathered${oneLine.htsus.replaceAll(".","")}`]:newMetaData.data.eventMessage});
          console.log('newMetaxData: ', newMetaData);
        
        });
      }

      const parentHTSObj = (this.state.ch82BuilderHash||[]).find(aaa=> aaa.isCommodityDuty == 1);
      let largestDutyRate = -999;
      let childHTSObj = null;
      let sumOfAllChildEnteredValues =0;
      let rateToUseX = 'column1Rate';
      for( let onepotentialbiggest of (this.state.ch82BuilderHash||[]).filter(aaa=>aaa.isCommodityDuty != 1)){
        sumOfAllChildEnteredValues += parseFloat(onepotentialbiggest?.enteredValue || 0);
        if(this.state[`metadataGathered${onepotentialbiggest.htsus.replaceAll(".","")}`]){
          const currentRate = parseFloat(this.state[`metadataGathered${onepotentialbiggest.htsus.replaceAll(".","")}`][rateToUseX] || 0);;
          if(largestDutyRate < currentRate){
            childHTSObj = onepotentialbiggest;
            largestDutyRate = currentRate;
          }
        }
      }

      return <>
        <Modal
          closeIcon
          open={this.state.ch82modalIsOpen}
          style={{width:"90vw"}}
          onClose={()=>{
            this.setState({
              ch82modalIsOpen: false,
              savingch82ModalData: false,
            });
          
          }}
          trigger={
            <Button onClick={() => { 
              this.setState({
                ch82modalIsOpen: true,
                ch82BuilderHash: allDuties.map(aa => {
                  return { 
                    merchandiseDutyId: aa.merchandiseDutyId,
                    isCommodityDuty: aa.isCommodityDuty,
                    htsus: aa.htsus,
                    dutyRate: aa.dutyRate,
                    enteredValue: aa.enteredValue
                   }
                }).filter(aaa=>(aaa.htsus||"").indexOf("82")==0)
              })


            }} style={{ fontWeight: 'bold', marginTop: '5px' }}>Ch.82 Set Reporting Applies. Open Set Builder?</Button>}
          >
          <Modal.Header>CH. 82 Set Builder</Modal.Header>
          <Modal.Content style={{ width: '100%' }}>
            <Modal.Description >

              <Grid padded className="nopadcol blk2" columns="equal" key={index}>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <h3>Set Builder</h3> 
                </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <Grid.Column className="no-field-margin dashedContainer">
                    Type
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    HTS
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Duty Rate
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Entered Value
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer" style={{flexGrow: '6'}}>
                    Description
                  </Grid.Column>
                </Grid.Row>
                {(this.state.ch82BuilderHash || []).map((ch82line,iiixi) => {
                  const myMetaData = this.state[`metadataGathered${(ch82line.htsus||"").replaceAll(".","")}`];
                  console.log('myMetaData: ', myMetaData);
                  return (
                    <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" key={ch82line.merchandiseDutyId}
                    
                      style={iiixi%2==1?{backgroundColor:'#eee'}:{}}
                    >
                      <Grid.Column className="no-field-margin"  style={{paddingTop:'0.6rem',paddingLeft:'2rem'}}>
                        <b>
                        {ch82line.isCommodityDuty==1?"Parent":<>
                        
                        <Icon
                          className={"hts-trash duty-item" }
                          name="trash alternate outline"
                          color={"red"}
                          disabled={this.state.savingch82ModalData}
                          onClick={() => {
                            this.setState({ch82BuilderHash:this.state.ch82BuilderHash.filter(aaa=>
                              aaa.merchandiseDutyId != ch82line.merchandiseDutyId)})
                          }}
                        />Child</>}</b>
                      </Grid.Column>
                      <Grid.Column className="no-field-margin" style={{padding:'0px'}}>
                        {ch82line.isCommodityDuty === 1 ?
                          <Dropdown
                            options={ch82SetHtsesAsDropdown}
                            text={ch82line.htsus}
                            id={ch82line.merchandiseDutyId +" htssssssssssssssxsss"}
                            lazyLoad={true}
                            selection
                            className="narrow"
                            disabled={this.state.savingch82ModalData}
                            onChange={(event, { value }) => {
                              let cloneOfState = JSON.parse(JSON.stringify(this.state.ch82BuilderHash));
                              cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).htsus = value;
                              this.setState({
                                ch82BuilderHash: cloneOfState,
                                anyChangeHasHappened: true
                              });
                            }}
                          /> :
                          <InputField
                            isLabel={false}
                            type={"text"}
                            className={"field-bg"}
                            label={<></>}
                            id={ch82line.merchandiseDutyId +" htsssssssssssssssss"}
                            labelClassName="name-label es"
                            value={ch82line.htsus}
                            disabled={this.state.savingch82ModalData}
                            onChange={(value) => {
                              let cloneOfState = JSON.parse(JSON.stringify(this.state.ch82BuilderHash));
                              let changeOccurred = cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).htsus != value;
                              if (changeOccurred) {
                                cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).showhtspopupInch82 = true;
                              }
                              cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).htsus = value;
                              this.setState({
                                ch82BuilderHash: cloneOfState
                              });

                            }}
                            onBlur={(value) => {
                              let cloneOfState = JSON.parse(JSON.stringify(this.state.ch82BuilderHash));
                              if ((cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).htsus||"").length >=8 ) {
                                cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).showhtspopupInch82 = false;
                                this.setState({
                                  ch82BuilderHash: cloneOfState,
                                  anyChangeHasHappened: true
                                });
                              }
                            }}
                            newValue={newValue}
                            fieldName={fieldName}
                            setINPUTID={setINPUTID}
                            penClicked={penClicked}
                            shipmentId={shipmentId}
                            rbCounterID={rbCounterID}
                            clearInput={true}
                          />}
                        {ch82line.showhtspopupInch82 && (
                          <HTSCodePopup
                            shipmentETA={itDate || entryDate}
                            code={ch82line.htsus}
                            mapCode={ch82line.htsus}
                            country={"US"}
                            hidehtspopup={()=>{
                              let cloneOfState = JSON.parse(JSON.stringify(this.state.ch82BuilderHash));
                              cloneOfState.find(aaa => aaa.merchandiseDutyId == ch82line.merchandiseDutyId).showhtspopupInch82 = false;
                              this.setState({
                                ch82BuilderHash: cloneOfState
                              });
                            }}
                            callbackwhenChanged={(value) => {
                              let cloneOfState = JSON.parse(JSON.stringify(this.state.ch82BuilderHash));
                              cloneOfState.find(aaa=>aaa.merchandiseDutyId == ch82line.merchandiseDutyId).htsus = value;
                              cloneOfState.find(aaa=>aaa.merchandiseDutyId == ch82line.merchandiseDutyId).showhtspopupInch82 = value.length<6;
                              this.setState({
                                ch82BuilderHash: cloneOfState,
                                anyChangeHasHappened: true
                              });

                            }}
                          />
                        )}
                      </Grid.Column>
                      <Grid.Column className="no-field-margin" style={{padding:'0.6rem'}}>
                        &nbsp;{myMetaData && myMetaData[rateToUseX]}%
                      </Grid.Column>
                      <Grid.Column className="no-field-margin"  style={{padding:'0px'}}>
                        
                      <InputField
                          isLabel={false}
                          type={"text"}
                          id={ch82line.merchandiseDutyId +" evvvvvvvvvvvv"}
                          label={<></>}
                          disabled={this.state.savingch82ModalData || ch82line.isCommodityDuty === 1}
                          labelClassName="name-label es"
                          value={ch82line.enteredValue}
                          onChange={(value) => {
                            let cloneOfState = JSON.parse(JSON.stringify(this.state.ch82BuilderHash));
                            cloneOfState.find(aaa=>aaa.merchandiseDutyId == ch82line.merchandiseDutyId).enteredValue = value;
                            this.setState({
                              ch82BuilderHash: cloneOfState,
                              anyChangeHasHappened: true
                            });
                           
                          }}
                          onBlur={(value) => {
                          }}
                          newValue={newValue}
                          fieldName={fieldName}
                          setINPUTID={setINPUTID}
                          penClicked={penClicked}
                          shipmentId={shipmentId}
                          rbCounterID={rbCounterID}
                          clearInput={true}
                        />
                      </Grid.Column>
                      <Grid.Column className="no-field-margin"  style={{padding:'0.6rem', whiteSpace:'nowrap', flexGrow: '6'}}>
                      {myMetaData && myMetaData['displayDescription']}
                      </Grid.Column>
                    </Grid.Row>
                  )
                })}
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row">

                  <Button primary style={{margin:'0.5rem'}}
                    disabled={this.state.savingch82ModalData}
                  onClick={() => {
                    this.setState({
                      ch82BuilderHash: [...this.state.ch82BuilderHash,
                      {
                        merchandiseDutyId: Math.random() + Date.now(),
                        isCommodityDuty: 2,
                        htsus: "",
                        dutyRate: 0,
                        enteredValue: 0
                      }
                      ],
                      anyChangeHasHappened: true
                    })
                  }}>+ Add</Button>
                  <div style={{ width: '100%', padding: '2.5rem' }}><hr style={{ width: "100%" }} /></div>
                 </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <h3>CBP Reporting</h3>
                  </Grid.Row>
               <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  The rate of duty for this line item is determined by the article in the set (the child HTS) subject to the highest rate of duty. Both Duty Rate and Entered Value will be Reported to CBP at the Child Level.
                </Grid.Row>
                <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                  <Grid.Column className="no-field-margin dashedContainer">
                    Type
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    HTS
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Duty Rate
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer">
                    Entered Value
                  </Grid.Column>
                  <Grid.Column className="no-field-margin dashedContainer" style={{ flexGrow: '6' }}>
                    Description
                  </Grid.Column>
                </Grid.Row>
                {childHTSObj?.htsus &&
                  <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" >
                    <Grid.Column className="no-field-margin">
                      Child
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      {childHTSObj?.htsus}
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      &nbsp;{largestDutyRate}%
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      {sumOfAllChildEnteredValues}
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" style={{ padding: '0.6rem', whiteSpace: 'nowrap', flexGrow: '6' }}>
                      {this.state[`metadataGathered${childHTSObj.htsus?.replaceAll(".", "")}`] &&
                        this.state[`metadataGathered${childHTSObj.htsus?.replaceAll(".", "")}`]['displayDescription']}
                    </Grid.Column>
                  </Grid.Row>
                }

                {parentHTSObj &&
                  <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" style={{ backgroundColor: '#eee' }}>
                    <Grid.Column className="no-field-margin">

                      Parent
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      {parentHTSObj.htsus}
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                    &nbsp;0.00%
                    </Grid.Column>
                    <Grid.Column className="no-field-margin">
                      0.00
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" style={{ padding: '0.6rem', whiteSpace: 'nowrap', flexGrow: '6' }}>
                      {this.state[`metadataGathered${parentHTSObj.htsus?.replaceAll(".", "")}`] &&
                        this.state[`metadataGathered${parentHTSObj.htsus?.replaceAll(".", "")}`]['displayDescription']}
                    </Grid.Column>
                  </Grid.Row>
                }
              </Grid>
            </Modal.Description>
            <Modal.Actions>
              <Button
                disabled={this.state.savingch82ModalData}
                primary style={{ margin: '0.5rem' }}
                onClick={async () => {
                  if(this.state.anyChangeHasHappened && !window.confirm("Are you sure? Data in the Set Builder will be lost"))return;
                  this.setState({
                    ch82modalIsOpen: false,
                  });
              
              }}>Cancel</Button>
              <Button
                disabled={!childHTSObj?.htsus || (childHTSObj?.htsus||"").indexOf("82")!=0 || ch82SetHtses.includes((childHTSObj?.htsus||"").replaceAll(".","")) || !parentHTSObj.htsus || this.state.savingch82ModalData}
                primary style={{ margin: '0.5rem' }}
                onClick={async () => {
                  this.setState({savingch82ModalData:true});
                  if(this.state.savingch82ModalData)return;
                  if ( this.props.enableLineItem ? false : isDisabled("dutyItem")) return;
                  const childIndexX = 0;
                  const parentIndexX = 1
                  const chinaTariffDuty = this.props.allDuties.find(aaa=>(aaa.htsus||"").replaceAll(".","").includes("990388")) ;
                  if(this.props.allDuties.length < parentIndexX + 1 || this.props.allDuties.indexOf(chinaTariffDuty) == parentIndexX){
                    //if there's a china tariff at index 1, move it down once
                    createMerchandiseDutyItem(
                      invoiceItemIndex,
                      this.props.invoiceId,
                      merchandiseId,
                      lineItemIndex,
                      this.dutyAddStatus,
                      parentHTSObj?.htsus,
                      get(this.props, 'pscData.pscShipmentId')
                    );
                    await new Promise(r => setTimeout(r, 2500));
                  }
                  changeHTSValueWithIndex(childHTSObj?.htsus, false, true, childIndexX);
                  await new Promise(r => setTimeout(r, 2500));
                  changeHTSValueWithIndex(parentHTSObj?.htsus, false, true, parentIndexX);
                  await new Promise(r => setTimeout(r, 2500));
                  await changeEnteredValueDutyLevel(sumOfAllChildEnteredValues,
                    lineItemIndex,
                    invoiceItemIndex,
                    childIndexX, this.props, allDuties, true)

                  await changeEnteredValueDutyLevel("0.00",
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX, this.props, allDuties, true)

                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    childIndexX,
                    "invoiceCurrencyValue",
                    (sumOfAllChildEnteredValues / (currencyExchangeInfo?.exchangeRate || 1)).toFixed(2)
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    childIndexX,
                    "invoiceCurrencyValue",
                    (sumOfAllChildEnteredValues / (currencyExchangeInfo?.exchangeRate || 1)).toFixed(2)
                  );
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    "0.00"
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    "0.00"
                  );


                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    0
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "invoiceCurrencyValue",
                    0
                  );


                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "charges",
                    0
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "charges",
                    0
                  );


                  updateMerchDutyItemObject(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "manifestQuantity",
                    "units",
                    "PCS"
                  );
                  await saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    parentIndexX,
                    "manifestQuantity"
                  );


                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    childIndexX,
                    "htsus",
                    childHTSObj?.htsus
                  );

                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    parentIndexX,
                    "htsus",
                    parentHTSObj?.htsus
                  );
                  
                  changeHTSValueWithIndex(childHTSObj?.htsus, false, true, childIndexX);
                  await new Promise(r => setTimeout(r, 3000));
                  changeHTSValueWithIndex(parentHTSObj?.htsus, false, true, parentIndexX);

                  await new Promise(r => setTimeout(r, 3000));
              
                  this.setState({
                    ch82modalIsOpen: false,
                    savingch82ModalData: false
                  });
              }}>{
                ch82SetHtses.includes((childHTSObj?.htsus||"").replaceAll(".",""))?"Invalid Child HTS":
                (childHTSObj?.htsus||"").indexOf("82")!=0?"Child must be CH.82":
              this.state.savingch82ModalData?"Saving":"Save"}</Button>
            </Modal.Actions>
          </Modal.Content>
        </Modal>
      </>
    }
    

  const overrideDutyRate =(
    invoiceItemIndex,
    lineItemIndex,
    dutyIndex, oneduty)=>{
    if (
      oneduty.dutyOverrideFlag !=
        1 &&
      !window.confirm(
        `Duty Override: Would you like to override the duty for HTS ${oneduty.htsus}?`
      )
    )
      return;
    updateMerchDutyItemFeild(
      invoiceItemIndex,
      lineItemIndex,
      dutyIndex,
      "dutyOverrideFlag",
      oneduty.dutyOverrideFlag != 1
        ? 1
        : 2 //1==true
    );
    return saveMerchDutyItem(
      lineItemIndex,
      invoiceItemIndex,
      dutyIndex,
      ["dutyOverrideFlag", "isCommodityDuty"]
    );
  }



     const changeHTSValue = async  (value, silent, deleteOldPGAs) => {
      return changeHTSValueWithIndex(value, silent, deleteOldPGAs, index)
    }
     const changeHTSValueWithIndex =async  (value, silent, deleteOldPGAs, index) => {
      if (this.props.launchFrom === 'PRODUCT_HISTORY') {
        return new Promise((resolve, reject) => { resolve({}); });
      }
      this.displayInvalidHtsError(value);

      //copied to merchandiselineitems HTS #
      if (value && value.indexOf("98") == 0) {
        if((window[`BOXCHECKRATELIMIT.dutyxClass${merchandiseId}--:not(:checked)`]||0) + 5000 < Date.now()){
          let dutyIndex = 0;
          for(let oneduty of this.props.merchandiseLineItem.merchandiseDuties){
            
            
            let overrideDutyLineItem = hasDutyOverride(oneduty, this.props.merchandiseLineItem.merchandiseDuties);
         
            if(oneduty.dutyOverrideFlag != 1 && overrideDutyLineItem){
              await overrideDutyRate(
                invoiceItemIndex,
                lineItemIndex,
                dutyIndex,oneduty)
            }
            dutyIndex++;
          }
        }
        window[`BOXCHECKRATELIMIT.dutyxClass${merchandiseId}--:not(:checked)`]=Date.now()
      }
      // let newhtsnoncommodity =
      //   isCommodityDuty === 2 &&
      //   value && value.indexOf("9802") != 0 &&
      //   (value.indexOf("98") == 0 || value.indexOf("99") == 0);
      // if (newhtsnoncommodity && !silent) {
      //   //99/98 chapter reset all this unused stuff// remember this is copied
      //   resetDutyItemFieldsInNonCommodity(
      //     updateMerchDutyItemObject,
      //     lineItemIndex,
      //     invoiceItemIndex,
      //     index,
      //     saveMerchDutyItem,
      //     updateMerchDutyItemFeild
      //   );
      // }

        const responseXYU = await saveMerchDutyItem(
          lineItemIndex,
          invoiceItemIndex,
          index,
          "htsus",
          (value||"").replace(/\./g, "")
        )
        
       if (
         value.replace(/\./g, "").length === 10 ||
         value.replace(/\./g, "").length === 8
       ) {
         await setHSDTL(
           itDate,
           { htsHasBeenLengthZero: this.state.htsHasBeenLengthZero, hsDtlCalledFrom: "htsus", parentThis: this, ...this.props.EntryTypeInfo },
           value,
           invoiceItemIndex,
           lineItemIndex,
           index,
           isCommodityDuty,
           false,
           this.props.invoiceId,
           this.props.merchandiseId,
           countryOfOrigin,
           this.props.merchandiseLineItem,
           (newHSDLData) => {
             for (let oneNewPga of newHSDLData?.pgaMetadata?.tarriffPgaDetails || []) {
               const possiblePrograms = oneNewPga?.programDetails?.map(aaa => aaa.formType);
               if (possiblePrograms.length != 1) continue;
               const alreadyAddedPgas = (this.props.pgaFlagInfos || []).map(aaa => aaa.pgaType);
               if (alreadyAddedPgas.includes(possiblePrograms[0])) continue;
               console.log('oneNewPga: ', alreadyAddedPgas, possiblePrograms);
               //only one option, and it hasn't been added yet=>
               // window.GLOBALLATEST_pgaFlagInfos[`${merchandiseId}pgaFlagInfos`] = this.props.pgaFlagInfos;
               if (!isWarehouseEntry(this.props.EntryTypeInfo)) {
                 this.props.createNewPgaSelection(possiblePrograms[0], false);
               }

             }

             deleteOldPGAs && this.deleteOldPGACVDData(value, true, newHSDLData)
           }
         );
         handleDutyItemContextSwitch(
           lineItemIndex,
           invoiceItemIndex,
           index
         );
         this.setState({ htsHasBeenLengthZero: false });
       }
          
        let fieldId = "htsus";
        this.validateField(
          `${lineItemIndex}-${index}-`,
          fieldId,
          value
        );
        if (isCommodityDuty === 1 && !["NONE"].includes(this.props.merchandiseLineItem.productClaimCode)) {
          updateMerchLineItemFeild(
            lineItemIndex,
            invoiceItemIndex,
            "productClaimCode",
            "NONE"
          );
          //&& this.props.merchandiseLineItem.productClaimCode === 'NONE'
          saveDescriptionOfMerchandiseLine(
            lineItemIndex,
            invoiceItemIndex,
            "productClaimCode",
            "NONE"
          );
        }
        let notRateLimited = (!window.LAST_AUTOUPDATE_global || window.LAST_AUTOUPDATE_global + 2000 < Date.now())
        if (notRateLimited) window.LAST_AUTOUPDATE_global = Date.now();

        let firsthts = index !== 0 && document.getElementsByClassName(merchandiseId + "commodityDuty1")[0];
        firsthts && notRateLimited && firsthts.dispatchEvent(new Event("blur"));
    }

    
    const initializeSteelCast = (hts,mainExclusionlistfromServer) => {
      let {updateMerchLineItemObject, saveDescriptionOfMerchandiseLine} = this.props
      if(!hts)return;
      hts = hts.replaceAll(".","");
      const isSteelMeltAndPourHts = steelMeltAndPourHTSBeginnings.find(xxx=>hts.startsWith(xxx));
      let updatedList = mainExclusionlistfromServer;

      let existingSteelMeltAndPourObject = updatedList.find(aaa=>aaa.countryOfMeltAndPour != "no" && aaa.typeCode ==  "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
      if(isSteelMeltAndPourHts){
        if(!existingSteelMeltAndPourObject || existingSteelMeltAndPourObject.steelMeltAndPourCountryDetail.countryOfMeltAndPour=="no"){
          updatedList = updatedList.filter(aaa=>aaa.typeCode !=  "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
          updatedList = updatedList.concat({
            typeCode: "STEEL_MELT_AND_POUR_COUNTRY_DETAIL",
            "steelMeltAndPourCountryDetail": {
              "countryOfMeltAndPour": "yes",
              "countryOfMeltAndPourCode": "",
              "countryOfMeltAndPourApplicabilityCode": "no"
          }
          });
        }
      } else {
        if (existingSteelMeltAndPourObject) {
          updatedList = updatedList.filter(aaa => aaa.typeCode != "STEEL_MELT_AND_POUR_COUNTRY_DETAIL");
          updatedList = updatedList.concat({
            typeCode: "STEEL_MELT_AND_POUR_COUNTRY_DETAIL",
            "steelMeltAndPourCountryDetail": {
              "countryOfMeltAndPour": "no",
              "countryOfMeltAndPourCode": "",
              "countryOfMeltAndPourApplicabilityCode": "no"
            }
          });
        }
      }

      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
      return updatedList;
    }

    const initializeAluminiumCast = (hts,mainExclusionlistfromServer) => {
      if(!hts)return;
      hts = hts.replaceAll(".","");
      const currentUIHTS = this.state.thisHTSFocused ? this.state.thisLocalHtsValue : htsus;
      let {importerAdditionalDeclarationDetails, updateMerchLineItemObject, saveDescriptionOfMerchandiseLine} = this.props
      const targetHTS = Object.values(russiaMetaData).map(a=>Object.keys(a)).reduce((a,b)=>a.concat(b),[]);
      let addAluminiumCast = targetHTS.filter(t => hts.startsWith(t)).length > 0;
      // check non-russia codes as well
      if(!addAluminiumCast){
        addAluminiumCast = aluminiumMeltAndPour.find(htsCode=>hts.startsWith(htsCode)) > 0
      }
      if(addAluminiumCast && mainExclusionlistfromServer.find(aaaa=>aaaa.typeCode == "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")){
        return mainExclusionlistfromServer;
      }
      let updatedList = mainExclusionlistfromServer.filter((a) => a.typeCode != "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL")

        updatedList = updatedList.concat({
          typeCode: "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL",
          "aluminumSmeltAndCastCountryDetail": (addAluminiumCast ? {
            "doNotShowAluminum": false,
            "isUsProduct": "no",
            "isPrimaryCountryOfSmeltApplied": "yes",
            "primaryCountryOfSmelt": "",
            "isSecondCountryOfSmeltApplied": "yes",
            "secondaryCountryOfSmelt": "",
            "countryOfCast": ""
          } : {
            "doNotShowAluminum": true,
            "isUsProduct": " ",
            "isPrimaryCountryOfSmeltApplied": "no",
            "primaryCountryOfSmelt": " ",
            "isSecondCountryOfSmeltApplied": "no",
            "secondaryCountryOfSmelt": " ",
            "countryOfCast": " "
          })
        })

      updateMerchLineItemObject(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', 'importerAdditionalDeclarationDetail', updatedList)
      return updatedList;
    }

    const exclusionHTSES = getExclusionHTSES(entryDate);


  const commodityDutysHTS =     ((allDuties||[]).find(duty=>duty.isCommodityDuty==1)?.htsus+"").trim().replaceAll(".","");
    let OctoberTwelve_TwentyTwentyOne = 1633996800000;
    let hasChinaExclusion = !!(countryOfOrigin === "CN" && entryDate >= OctoberTwelve_TwentyTwentyOne && htsus 
      && htsus.startsWith("9903") &&  exclusionHTSES.includes(commodityDutysHTS) && subExclusionHTSES.includes(htsus));
    const isNinetyNineDuty = htsChapter == "99" && htsus.replace(/\./g, "")!="99039008";
    let overrideDutyLineItem = (isNinetyNineDuty || isCommodityDutyBoolean) && hasAnyNinetyEightDuty;
    // let incorrectHts = htsChapter > 9 && (incorrectHTSForNonCommodity || incorrectHTSForCommodity)
    const currentUIHTS = this.state.thisHTSFocused ? this.state.thisLocalHtsValue : htsus;

    const enteredValueFieldX =
      !commodityHTSOrPrimaryCommodity
        ? enteredValueZeroIndex
        : currentEnteredValuex;

    const ch82BehaviorForChargesAndDuties =   ch82SetHtses.includes((htsus||"").replaceAll(".","")) && !isCommodityDutyBoolean;
    let thirdLinePlusBehaviorForCh82 = false;
    if(!!allDuties?.length && allDuties.length>=3 && ch82SetHtses.includes((allDuties[1].htsus||"").replaceAll(".","")) && !isCommodityDutyBoolean){
      if(!(allDuties[2].htsus||"").replaceAll(".","").startsWith("990388") && index ==2 ){
        thirdLinePlusBehaviorForCh82 = true;
      } else if((allDuties[2].htsus||"").replaceAll(".","").startsWith("990388") && index == 3 ){
        thirdLinePlusBehaviorForCh82 = true;
      }
    } 
    return (
      <div className="duty-item-line">
        {thirdLinePlusBehaviorForCh82 && 
        <div style={{color:'red'}} className="dashedContainer" >
        CBP Reporting of Ch.82 Sets expects two tariffs: the set header and the set article with highest duty rate. Please delete additional Ch.82 tariffs
        </div>
        }
        <Grid padded className="nopadcol blk2" columns="equal" key={index}>
          <Grid.Row className="isCommodityDuty hts-description-row merged hts-row" style={{display:'none'}}></Grid.Row>
          <Grid.Row
            className={(
              isCommodityHTS
                ? "isCommodityDuty hts-description-row merged hts-row"
                : "hts-description-row merged hts-row top-margin-prod-hist"
            )+(isCommodityDuty === 1?" iscommoditydutyline ":" ")
          }
          >
            {isCommodityDuty === 2 &&
              (!this.state.isDeletingHTS ? (
              <Popup
                basic
                content='Remove subduty'
                // disabled={!hasanyoverrideflag(allDuties)/* disabled = don't show the message */}
                trigger={
                <Icon
                  className={isCommodityDuty === 2 ? "hts-trash duty-item" : ""}
                  name="trash alternate outline"
                  color={"red"}
                  disabled={
                    this.props.enableLineItem ? false : isDisabled("dutyItem")
                  }
                  onClick={() => {
                  confirmAlert({
                    closeOnClickOutside: false,
                    title: `Subduty ${htsus} will be deleted. ${hasanyoverrideflag(allDuties)?"All duty overrides will be cleared.":""} Are you sure?`,
                    buttons: [
                      {
                        label: <b>Confirm</b>,
                        onClick: async () => {
                          
                          if(hasanyoverrideflag(allDuties)){

                            let dutyIndex = 0;
                            for(let onedutyxx of this.props.merchandiseLineItem.merchandiseDuties){
                              let overrideDutyLineItem = hasDutyOverride(onedutyxx, this.props.merchandiseLineItem.merchandiseDuties);
                              if(onedutyxx.dutyOverrideFlag == 1 && overrideDutyLineItem){
                                await overrideDutyRate(
                                  invoiceItemIndex,
                                  lineItemIndex,
                                  dutyIndex,onedutyxx)
                              }
                              dutyIndex++;
                            }

                          }
                          this.setState({
                            isDeletingHTS: true,
                          });
                          removeDutyItem(
                            merchandiseId,
                            [merchandiseDutyId],
                            lineItemIndex,
                            invoiceItemIndex,
                            0,//unused
                            this.deleteHtsStatus,
                            pscData.pscShipmentId
                          );
                          setTimeout(()=>{
                            let firsthtscode = document.getElementsByClassName(merchandiseId+"commodityDuty1")[0];
                            let firsthts = index !== 0 && firsthtscode
                            firsthts && firsthts.dispatchEvent(new Event("blur"));
                          },300)

                        }
                      },
                      {
                        label: `Cancel`,
                        onClick: () => {}
                      }
                    ]
                  })

                  
                  }}
                />
                }/>
              ) : (
                <Loader
                  active
                  inline
                  size="mini"
                  className="duty-item-loader"
                />
              ))}
            <Grid.Column className={"borderStart noBorderRadius"}>
              <UpdateTariffs invoiceId={this.props.invoiceId} merchandiseId={merchandiseId}>
             {({updateHTS})=> <InputField
                isLabel={false}
                id={`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`}
                disabled={
                  this.props.launchFrom === "PRODUCT_HISTORY" ? true : (
                  this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem"))
                }
                type={"text"}
                saveOnTabOut={true}
                className={(() => {
                  let className = "field-bg";
                  if(this.props.launchFrom === "PRODUCT_HISTORY" && isCommodityDuty === 2)
                    className = "field-bg down-border";
                  if (isCommodityDuty === 2) {
                    className += ` right-border ${merchandiseId}commodityDuty2 `;
                  } else {
                    className += ` ${merchandiseId}commodityDuty1 `;
                    
                  }
                  if (
                    htsus?.replace(/\./g, "").length !== 10 &&
                    htsus?.replace(/\./g, "").length !== 8
                  ) {
                    className += " redBgColor";
                  }
                  return className;
                })()}
                labelIcon={
                  isCommodityDuty === 1 && footnote !== "NA" && footnote
                    ? getPopUpIcon(
                        "info circle",
                        footnote,
                        "hts-note",
                        merchandiseId,
                        lineItemIndex
                      )
                    : null
                }
                label={
                  <>
                HTS #
                  {htsus !== "" &&
                  ( (htsus.replace(/\./g, "").length === 4 )||
              ( htsus.replace(/\./g, "").length === 6) ||
              ( htsus.replace(/\./g, "").length === 8) ||
                ( htsus.replace(/\./g, "").length ===
                          10 )                   ) && 
                      (       <React.Fragment><Popup
                        trigger={
                          <Icon
                            style={{
                              paddingLeft: "3px",
                              position: "relative",
                              float: "right",
                              color: "blue",
                              cursor: "pointer",
                            }}
                         
                            name="external alternate"
                            className="close link icon"
                            onClick={() => {
                           
                              window.open(
                        `https://hts.usitc.gov/?query=${htsus}`,
                        "_blank"
                      );
                            
                       
                            }}
                          />
                        }
                      
                        content={"Go to Tariff Details"}
                      />
                      <CopyToClipboard text={htsus} />
                      {
                        (htsus?.replace(/\./g, "").length === 10 || 
                        htsus?.replace(/\./g, "").length === 8) &&  
                      <QryFuncModal
                        brokerId={window.brokerId}
                        brokerGuid={this.props.currentJobData?.brokerGuid}
                        launchFrom={"MERCHANDISE_LINE"}
                        hideLeftPanel={true}
                        dataType={"HTS"}
                        width={"75%"}
                        shipId={shipmentId}
                        hts={htsus}
                        recentQryCall={false}
                        baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                        buttontext={`HTS Query`}
                        asOfDate={this.getAsOfDate()}
                      />
                      }
                      </React.Fragment>)}
                </>
                }
                value={currentUIHTS}
                errors={(() => {
                  let myErrorList = [];
                  // if(incorrectHts){myErrorList.push("HTS code chapter issue:")}
                  // if(incorrectHTSForNonCommodity){myErrorList.push("Invalid HTS code for non commodity (HTS code begining with 98-99 required)")}
                  // if(incorrectHTSForCommodity){myErrorList.push("Invalid HTS code for commodity (HTS code begining with 01-97 required)")}

                  if (
                    htsus?.replace(/\./g, "").length !== 10 &&
                    htsus?.replace(/\./g, "").length !== 8
                  ) {
                    if(this.state.htsError!==200 && ((window.GLOBAL_SETSTATERATELIMITSAFETY_kvsavk||0)+2500<Date.now())){
                      window.GLOBAL_SETSTATERATELIMITSAFETY_kvsavk = Date.now();
                      this.setState({ htsError: 200 });
                    }
                    myErrorList.push("HTS code wrong length");
                  } else if (this.state.htsError == 400 || this.state.htsError === 404) {
                    myErrorList.push(" HTS code entered was not found in Database. HTS might not exist for this entry date.");
                  }

                  if (
                    isCommodityDuty === 1 &&
                    indexVal === 0 &&
                    parentHts &&
                    htsus?.replace(/\./g, "") !== parentHts?.replace(/\./g, "")
                  ) {
                    myErrorList.push(
                      "HTS code of first Article:V should be equal to the HTS code of Article:X"
                    );
                  }
                  if (
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${"htsus"}${merchandiseDutyId}`
                    ]
                  ) {
                    myErrorList = myErrorList.concat(
                      fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${"htsus"}${merchandiseDutyId}`
                      ]
                    );
                  }

                  return myErrorList;
                })()}
                handleFocus={() => {
                  this.props.handleFocusMID && this.props.handleFocusMID();
                  this.setState({thisHTSFocused:true})
                  this.setState({thisLocalHtsValue:currentUIHTS})
                }}
                onChange={(value) => {
                  this.setState({thisLocalHtsValue:value,thisHTSFocused:true, localChangeHassOccurred:true})
                  this.setState({ showhtspopup: true });
                }}
                onBlur={async (value)=>{
                  if(isCommodityDuty === 1)
                  await updateHTS({htsNo: value})
                  // if((window.disableHTSBlurTemporarily||0)+1000 > Date.now()){
                  //   document.getElementById(`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus${shipmentId}`) && 
                  //     document.getElementById(`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus${shipmentId}`).focus();
                  //   return;
                  // }
                  if(value)value=value.trim();
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    return;
                  }
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    "htsus",
                    value
                  );
                  changeHTSValue(value,false,isCommodityDutyBoolean && this.state.localChangeHassOccurred)
                  if(isCommodityDutyBoolean){
                    let { importerAdditionalDeclarationDetails } = this.props
                    
                    let mainExclusionlistfromServer = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
                    const initialState = JSON.parse(JSON.stringify(_.get(importerAdditionalDeclarationDetails, 'importerAdditionalDeclarationDetail', [])));
                    mainExclusionlistfromServer = initializeSteelCast(value,mainExclusionlistfromServer);
                    mainExclusionlistfromServer= initializeAluminiumCast(value,mainExclusionlistfromServer);
                    if(!_.isEqual(mainExclusionlistfromServer,initialState)){
                      saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'importerAdditionalDeclarationDetails', {importerAdditionalDeclarationDetail :mainExclusionlistfromServer})
                    }
 
                  }
                  this.setState({thisHTSFocused:false,localChangeHassOccurred:false})
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />}
              </UpdateTariffs>       
              <Icon
                style={{
                  color: htsus.replace(/\./g, "").length > 10 ?"#ddd"  :"#2185d0",
                  cursor: "pointer",
                  marginTop: "-23px",
                      position: "relative",
                      float: "right",
                      fontSize: "1.3rem"
                }}
                name={`sort amount down`}
                className="hts-dropdown-icon"
                disabled={htsus.replace(/\./g, "").length > 10 ? true : false}
                onClick={()=>{this.setState({showhtspopup:true})}}
              />
            
            </Grid.Column>
            {!!(isCommodityDuty == 1&& !['-999',''].includes(categoryCode)) && parseInt(categoryCode)>0 &&
            <Grid.Column width={2} className="borderEnd hts-description-input noRightBorders  noBorderRadius">
              <InputField
                isLabel={false}
                id={`${lineItemIndex}${index}categoryCode`}
                errors={
                  fieldValidation?.validObjects_bl[
                    `Merchandiseqwqr${"categoryCode"}${merchandiseDutyId}`
                  ]
                }
                disabled={
                  this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                  ( this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem"))
                }
                type={"text"}
                className={(this.props.launchFrom === "PRODUCT_HISTORY" && isCommodityDuty === 2) ? "field-bg down-border" : "field-bg"}
                label={<>Textile Cat</>}
                labelClassName="name-label es"
                value={categoryCode}
                onChange={(value) => {
                  updateMerchLineItemFeild(
                    lineItemIndex,
                    invoiceItemIndex,
                    'categoryCode',
                    value
                  )
                }}
                onBlur={(value) => {
                  if (this.props.launchFrom === 'PRODUCT_HISTORY') {
                    return
                  }
                  saveDescriptionOfMerchandiseLine(
                    lineItemIndex,
                    invoiceItemIndex,
                    'categoryCode'
                  )
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                clearInput={true}
              />
            </Grid.Column>
          }

            <span style={{display:'none'}}>{!(
              this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                (this.props.enableLineItem === true
                  ? false
                  : isDisabled("dutyItem"))) && !this.state.htsDescriptionFocusedTrue && hsDataDtlForThisDuty?.displayDescription && !window[merchandiseDutyId+"SAVEDDUTYDESCRIPTION"] && (!htsDescription || !(htsDescription || "").trim()) && <>

                {(() => {
                  window[merchandiseDutyId+"SAVEDDUTYDESCRIPTION"]=true
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    "htsDescription",
                    hsDataDtlForThisDuty?.displayDescription
                  );
                  saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "htsDescription",
                    hsDataDtlForThisDuty?.displayDescription,
                    hsDataDtlForThisDuty?.priorityNumber
                  );
                })()}</>}
            </span>
            <Grid.Column className="borderEnd hts-description-input  noBorderRadius">
              <InputField
                isLabel={false}
                id={`${lineItemIndex}${index}htsDescription`}
                errors={
                  fieldValidation?.validObjects_bl[
                    `Merchandiseqwqr${"htsDescription"}${merchandiseDutyId}`
                  ]
                }
                disabled={
                  this.props.launchFrom === "PRODUCT_HISTORY" ? true :
                  ( this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem"))
                }
                type={"text"}
                className={(this.props.launchFrom === "PRODUCT_HISTORY" && isCommodityDuty === 2) ? "field-bg down-border" : "field-bg"}
                label={"HTS DESCRIPTION"}
                labelClassName="name-label es"
                value={htsDescription}
                onChange={(value) => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    this.props.updateFormState("htsDescription", value, "merchandiseDuties.duties", index)
                    return;
                  }
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    "htsDescription",
                    value
                  );
                }}
                handleFocus={() => {
                  this.setState({htsDescriptionFocusedTrue:true})
                  this.props.handleFocusMID && this.props.handleFocusMID();
                  this.setState({ showhtspopup: false }); //hide the popup when we tab from the hts field
                }}
                onBlur={(value) => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    return;
                  }
                  saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "htsDescription"
                  );
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                clearInput={true}
              />
            </Grid.Column>
            {this.state.showhtspopup && (
             <HTSCodePopup
                topIndex={index}
                saveMerchDutyItem={saveMerchDutyItem}
                lineItemIndex={lineItemIndex}
                getSelectedCode={updateMerchDutyItemFeild}
                shipmentETA={itDate || entryDate}
                code={currentUIHTS}
                mapCode={currentUIHTS}
                disabled={
                  this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem")
                }
                country={"US"}
                setHSDTL={(hts) => {
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    "htsus",
                    hts
                  );
                  saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "htsus"
                  );
                  setHSDTL(
                    itDate,
                    {htsHasBeenLengthZero:this.state.htsHasBeenLengthZero, parentThis: this, ...this.props.EntryTypeInfo},
                    hts,
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    isCommodityDuty,
                    false,
                    this.props.invoiceId,
                    merchandiseId,
                    countryOfOrigin,
                    this.props.merchandiseLineItem,
                  );
                  handleDutyItemContextSwitch(
                    lineItemIndex,
                    invoiceItemIndex,
                    index
                  );
                }}
                hidehtspopup={this.hidehtspopup}
                callbackwhenChanged={async (value) => {
                  value = value.replace(/\./g, "");
                  this.setState({thisLocalHtsValue:value});
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    "htsus",
                    value
                  );
                  if (
                    value.length === 10 ||
                    value.length === 8
                  ) {
                    setHSDTL(
                      itDate,
                      {htsHasBeenLengthZero:this.state.htsHasBeenLengthZero, parentThis: this, ...this.props.EntryTypeInfo},
                      value,
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      isCommodityDuty,
                      false,
                      this.props.invoiceId,
                      merchandiseId,
                      countryOfOrigin,
                      this.props.merchandiseLineItem,
                      (newHSDLData)=>{
                        
                        this.deleteOldPGACVDData(value.replace(/\./g, ""),index===0,newHSDLData)}
                    );
                    handleDutyItemContextSwitch(
                      lineItemIndex,
                      invoiceItemIndex,
                      index
                    );
                  }
                  saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "htsus"
                  );
                  let fieldId = "htsus";
                  this.validateField(
                    `${lineItemIndex}-${index}-`,
                    fieldId,
                    value
                  );
                  this.setState({ htsus: value });
                  setTimeout(()=>{
                    let firsthts = document.getElementsByClassName(merchandiseId+"commodityDuty1")[0]
                    firsthts && firsthts.dispatchEvent(new Event("blur"));
                  },200)
                }}
              />
            )}
          </Grid.Row>
          {ch82SetHtses.find(ch82grouping => (htsus || "").replaceAll(".", "").startsWith(ch82grouping)) && isCommodityDuty === 1 && 
           !(
            this.props.launchFrom === "PRODUCT_HISTORY" ? true :
            ( this.props.enableLineItem === true
              ? false
              : isDisabled("dutyItem")))
          &&
          <>
            <Grid.Row className="merged hts-row last-row prod-hist-display finalRowz ">
              <Grid.Column
                style={{ borderTop: isCommodityHTS ? "1px solid gray" : "" }}
                className="no-field-margin"
              >
                {ch82SetForm()}
              </Grid.Column>
            </Grid.Row>
          </>}
          {((isCommodityDuty === 1 || (isCommodityDuty === 1 && this.props.launchFrom === 'PRODUCT_HISTORY')) && 
            this.props.showLineItem) &&
            this.props.MerchandiseLineItem_co}
          <Grid.Row className="merged hts-row prod-hist-display new-mid-row finalRowz " style={{marginBottom: "0px important"}}>
             {/*START ENTERED VALUE*/}
             {
              isTarget 
              &&
              commodityHTSOrPrimaryCommodity
              &&
              <Grid.Column
              className={
                articleHeader === "V"
                  ? `borderEnd no-field-margin`
                  : `no-field-margin`
              }
            >
               <SelecTextField
                    blockOnBlur={true}
                    isLabel={false}
                    dropdownDirectionParam={'center'}
                    divClassName="secColn left-border-bottom"
                    inputName={`${lineItemIndex}${index}invoiceQuantity.weight`}
                    ignoreTabOnInputField={true}
                    disabled={
                      this.props.enableLineItem === true
                        ? false
                        : isDisabled("dutyItem")
                    }
                    selectName="grossWeight.weightUnits"
                    type="text"
                    id={"grossWeight.weightUnits"+merchandiseId+merchandiseDutyId}
                    label={<React.Fragment>INV QTY 
                      {this.state.isINVQtyUpdating && <Loader
                      active
                      inline
                      size="mini"
                      style={{ marginRight: "10px" }}
                    />}</React.Fragment>}
                    width={"16"}
                    textfieldSize={16}
                    className="field-bg"
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    options={unitList}
                    value={invoiceQuantity}
                    isInteger={true}
                    dropDownValue={invoiceQuantityUnits}
                    updateValue={(value) => {
                      if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                        invoiceQuantity.quantity = value;
                        this.props.updateFormState("invoiceQuantity", invoiceQuantity, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "invoiceQuantity",
                        "quantity",
                        value.replace(/[^\d.-]/g, "")
                      );
                
                    }}
                    updateDropDownValue={(value)=>this.handleInvoiceQuantityUnitBlur({
                      isTarget,
                      lineItemIndex,  
                      invoiceItemIndex, 
                      index,  
                      invoiceQuantity, 
                      invoiceQuantityUnits, 
                      manifestQuantityUnits, 
                      additionalQuantityUnits,
                      value,
                      hasCbpQty2: hsDataDtl?.unit2
                    })}
                    onBlur={()  =>{
                    this.setState({isINVQtyUpdating:true})
                    this.handleInvoiceQuantityBlur({
                      isTarget,
                      lineItemIndex,  
                      invoiceItemIndex, 
                      index,  
                      invoiceQuantity, 
                      invoiceQuantityUnits, 
                      manifestQuantityUnits, 
                      additionalQuantityUnits,
                      hasCbpQty2: hsDataDtl?.unit2
                      },()=>{
                        this.setState({isINVQtyUpdating:false})
                      })
                    }
                    }
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
            </Grid.Column>}
            {/*END ENTERED VALUE*/}
            {/*START Unit price */}
            {((isCommodityDuty == 1 || (isCommodityHTS && !is9802Hts)) && isTarget)&& (
              <Grid.Column className="no-field-margin">
                <InputField
                  subLabelText="$"
                  disabled={
                    this.state.isINVQtyUpdating || ch82BehaviorForChargesAndDuties || (
                    this.props.enableLineItem === true
                      ? false
                      : isDisabled("dutyItem"))
                  }
                  subLabelClass="left-icon"
                  subLabelToFixed={4}
                  id={`${lineItemIndex}-${index}-charges`}
                  type={"text"}
                  className={"field-bg"}
                  label={<React.Fragment>Unit price 
                    {this.state.isUnitPriceUpdating && <Loader
                    active
                    inline
                    size="mini"
                    style={{ marginRight: "10px" }}
                  />}</React.Fragment>}
                  
                  errors={
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${"dutyitemcharges"}${merchandiseDutyId}`
                    ]
                  }
                  value={unitPrice}
                  isInteger={true}
                  handleFocus={(e) => {
                    // e.target.select();
                  }}
                  onChange={(value) => {
                    
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("unitPrice", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "unitPrice",
                      value.replace(/[^\d.-]/g, "")
                    );
                  }}
                  onBlur={(value) => {
                    this.setState({isUnitPriceUpdating:true})
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    let newValue = parseFloat(value || 1);
                    // Charges should be a minumum of $1
                    // if (newValue < 1) {
                    //   newValue = 1;
                    // }
                    
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "unitPrice",
                      newValue.toFixed(4)
                    );
                    saveMerchDutyItem(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "unitPrice",
                      "",
                      "",
                      (value)=>{
                        this.setState({grossValueLocal:value,grossValueLocalFocused:true,isUnitPriceUpdating:false})
                      }
                    );
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
                {/* <Warning
                    fieldName={'charges'}
                    merchandiseId={merchandiseId}
                    warningValue={charges}
                  /> */}
              </Grid.Column>
            )}
            {/* Start gross value */}
            {(hasForeignCurrency || ( isCommodityDuty === 1 )) && 
            <Grid.Column className="no-field-margin">
              {/* {commodityHTSOrPrimaryCommodity?} */}
                <InputField
                  subLabelText={currencyExchangeInfo.fromIsoCurrencyCode}
                  subLabelClass="left-icon"
                  id={`${lineItemIndex}${index}invoiceCurrencyValue`}
                  type={"text"}
                  maxlength={10}
                  className={"field-bg"}
                  label={"GROSS VALUE"}
                  saveOnTabOut={true}
                  errors={
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${"invoiceCurrencyValue"}${merchandiseDutyId}`
                    ]
                  }
                  value={this.state.grossValueLocalFocused?this.state.grossValueLocal:invoiceCurrencyValue}
                  handleFocus={(e) => {
                    this.setState({grossValueLocal:invoiceCurrencyValue,grossValueLocalFocused:true})
                    e.target.select();
                  }}
                  disabled={
                    this.state.isINVQtyUpdating || this.state.isUnitPriceUpdating || articleHeader === "X" ||
                    (this.props.enableLineItem === true
                      ? false
                      : !commodityHTSOrPrimaryCommodity || isDisabled("dutyItem"))
                  }
                  onChange={(value) => {
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "invoiceCurrencyValue",
                      parseFloat(value || 0).toFixed(2)
                    );
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("charges", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    this.setState({grossValueLocal:value, grossValueLocalFocused:true})
                  }}
                  isInteger={true}
                  onBlur={(value) => {
                    this.setState({grossValueLocalFocused:false})
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    // Only perform changes if the field was touched (value was edited)
                    
                    changeEnteredValueDutyLevel(showFrightData?value * currencyConversionRate:value * currencyConversionRate,
                      lineItemIndex,
                      invoiceItemIndex,
                      index, this.props,allDuties,true,"invoiceCurrencyValue",(value)=>{
                        this.setState({enteredValueThisFocused:true,enteredValueThisFocusedValue:value})
                      })
                    
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
            </Grid.Column>
            }
           
                        {/*START ENTERED VALUE*/}
         {((showFrightData === false || is9802Hts) && !isTotalAdditionDeduction) || hasForeignCurrency ? <Grid.Column
              className={
                articleHeader === "V"
                  ? `borderEnd no-field-margin borderEnd`
                  : `no-field-margin borderEnd`
              }
            >
              <InputField
                subLabelText="$"
                subLabelClass="left-icon"
                id={`${lineItemIndex}${index}enteredValue`}
                type={"text"}
                maxlength={10}
                className={"field-bg"}
                saveOnTabOut={true}
                label={
                  (showFrightData === false || is9802Hts) && !isTotalAdditionDeduction ? "ENTERED VALUE" : 
                  hasForeignCurrency? "CONVERTED VALUE":
                  "GROSS VALUE"
                  
                }
                errors={
                  fieldValidation?.validObjects_bl[
                    `Merchandiseqwqr${"enteredValue"}${merchandiseDutyId}`
                  ] || displayErrorForEnteredValue
                }
                value={this.state.enteredValueThisFocused?this.state.enteredValueThisFocusedValue:
                  enteredValueFieldX
                } //98-99 we show the zero index
                handleFocus={(e) => {
                  this.setState({enteredValueThisFocused:false,enteredValueThisFocusedValue:enteredValueFieldX})
                  e.target.select();
                }}
                disabled={
                  this.state.isINVQtyUpdating || this.state.isUnitPriceUpdating || ch82BehaviorForChargesAndDuties || 
                  !commodityHTSOrPrimaryCommodity ||
                  (hasForeignCurrency && isCommodityDutyBoolean ) ||
                  articleHeader === "X" ||
                  (this.props.enableLineItem === true
                    ? false
                    : !commodityHTSOrPrimaryCommodity || isDisabled("dutyItem"))
                }
                onChange={(value) => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    this.props.updateFormState("enteredValue", value, "merchandiseDuties.duties", index)
                    return;
                  }
                  this.setState({enteredValueThisFocusedValue:value, previousEnteredValue: true});
                  if(!showFrightData)value=Math.round(value||0).toString();
                  displayErrorMsgForEnterValue(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "enteredValue",
                    [],
                    value
                  ); //reset error
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    index,
                    "enteredValue",
                    value.replace(/[^\d.-]/g, "")
                  );
                  // if(!invoicehasForeignCurrency){
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "invoiceCurrencyValue",
                      (parseFloat(value || 0) / (currencyConversionRate||1)).toFixed(2) 
                    );
                  // }
                }}
                onBlur={(value) => {
                  this.setState({previousEnteredValue: false});
                  if(!this.state.previousEnteredValue){
                    // do not save call if there is no change in the value
                    return;
                  }

                  if(!showFrightData)value=Math.round(value||0)
                  this.setState({enteredValueThisFocused:false,enteredValueThisFocusedValue:"No show"})
                  changeEnteredValueDutyLevel(value,
                    lineItemIndex,
                    invoiceItemIndex,
                    index, this.props,allDuties,true,"enteredValue").then((resp)=>{
                    // if(!invoicehasForeignCurrency){
                      
                        saveMerchDutyItem(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "invoiceCurrencyValue"
                        );
                      });
                    // }
                  
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
            </Grid.Column>:null}
            {/*END ENTERED VALUE*/}
             {!isCommodityDutyBoolean && hasChinaExclusion && (
              <Grid.Column
              style={{ borderTop: isCommodityHTS ? "1px solid gray" : "" }}
                className="no-field-margin"
              >
              {/*START disclaim china*/}
                <Checkbox
                  className="name-label es"
                  label={"China exclusion"
                  }
                  disabled={
                    this.props.launchFrom === "PRODUCT_HISTORY" ? true : (
                    this.props.enableLineItem === true
                      ? false
                      : isDisabled("dutyItem"))
                  }
                  checked={chinaExlcusionHTSTriggers(entryDate).map(a=>a.replaceAll(".","")).includes(htsus)}
                  onChange={async (event,value) => {
                    if (!chinaExlcusionHTSTriggers(entryDate).map(a=>a.replaceAll(".","")).includes(htsus)) {
                      let exclusionButtons = [
                        {
                          label: `Cancel`,
                          onClick: () => { }
                        }
                      ];
                      
                      for (let exclusionHTS of chinaExlcusionHTSTriggers(entryDate)) {
                        let noperiodsHTS = exclusionHTS.replaceAll(".","");
                        exclusionButtons.unshift({
                          label: <b>{exclusionHTS} Exclusion</b>,
                          onClick: () => {
                            localStorage.setItem(`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`, htsus)
                            updateMerchDutyItemFeild(
                              invoiceItemIndex,
                              lineItemIndex,
                              index,
                              "htsus",
                              noperiodsHTS
                            );

                            changeHTSValue(noperiodsHTS, true, false)


                            updateMerchDutyItemFeild(invoiceItemIndex,lineItemIndex,index,"chinaExclusionFlag",'1');
                            saveMerchDutyItem(lineItemIndex,invoiceItemIndex,index,"chinaExclusionFlag"
                            );

                          }
                        })
                      }
                      confirmAlert({
                        closeOnClickOutside: true,
                        title: `Claim the China exclusion for this line item. `,
                        buttons: exclusionButtons
                      })
                    } else {

                     
                      let nonChinaHTS = localStorage.getItem(`${invoiceItemIndex}-${lineItemIndex}-${index}-htsus`)||"";
                      updateMerchDutyItemFeild(invoiceItemIndex,lineItemIndex,index,"htsus",nonChinaHTS);

                      changeHTSValue(nonChinaHTS, true,false)

                      
                      updateMerchDutyItemFeild(invoiceItemIndex,lineItemIndex,index,"chinaExclusionFlag",'2');
                      saveMerchDutyItem(lineItemIndex,invoiceItemIndex,index,"chinaExclusionFlag");
                    }
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
              {/*END disclaim china*/}


              </Grid.Column>
            )}
          </Grid.Row>
          <Grid.Row className={`merged hts-row  prod-hist-display ${isCommodityDuty==1 ? "" :"last-row finalRowz"  }`}>
                      {commodityHTSOrPrimaryCommodity && (
              <>
                <Grid.Column
                  className={
                    !commodityHTSOrPrimaryCommodity
                      ? "hide-element  borderStart"
                      : "borderStart"
                  }
                >
                  <SelecTextField
                    isLabel={false}
                    dropdownDirectionParam={'center'}
                    divClassName="secColn"
                    inputName={`${lineItemIndex}${index}manifestQuantity.weight`}
                    ignoreTabOnInputField={true}
                    errors={(() => {
                  let myErrorList = [];
              
            
                  if (
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                    ]
                  ) {
                    myErrorList = myErrorList.concat(
                      fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                      ]
                    );
                  }
                  if(this.getValidationBasedOnHts(manifestQuantityUnits,manifestQuantityQuantity ,"NET QTY-HTS UNIT" ).length > 0 ){
                    myErrorList = myErrorList.concat(
                      this.getValidationBasedOnHts(manifestQuantityUnits,manifestQuantityQuantity ,"NET QTY-HTS UNIT")
                    );
                  }

                  return myErrorList;
                })()}
                    // errors={
                    //   fieldValidation.validObjects_bl[
                    //     `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                    //   ]||this.state.hasAdditionalUOMFValidation
                    // }
                    disabled={
                      this.props.enableLineItem === true
                        ? false
                        : isDisabled("dutyItem")
                    }
                    selectName="grossWeight.weightUnits"
                    type="text"
                    id={"grossWeight.weightUnits"+merchandiseId+merchandiseDutyId}
                    label={isTarget ? "CBP QTY 1" : "NET QTY-HTS UNIT"}
                    width={"16"}
                    textfieldSize={16}
                    className="field-bg"
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    options={unitList}
                    value={manifestQuantityQuantity}
                    isInteger={true}
                    dropDownValue={manifestQuantityUnits}
                    updateValue={(value) => {
                      if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                        manifestQuantity.quantity = value;
                        this.props.updateFormState("manifestQuantity", manifestQuantity, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity",
                        "quantity",
                        value.replace(/[^\d.-]/g, "")
                      );
                
                    }}
                    updateDropDownValue={(value) => {
                      if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                        manifestQuantity.units = value;
                        this.props.updateFormState("manifestQuantity.units", manifestQuantity, "merchandiseDuties.duties", index)
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity",
                        "units",
                        value
                      );
                      document.getElementById("VALIDATE_FORM_BUTTON") &&
                        document.getElementById("VALIDATE_FORM_BUTTON").click();

                  
                    }}
                    onBlur={(value) => {
                      if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                        return;
                      }
                      updateMerchDutyItemObject(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity",
                        "quantity",
                        parseFloat(manifestQuantityQuantity || 0).toFixed(2)
                      );
                 
                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "manifestQuantity"
                      );
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                  {/* <Warning
                fieldName={'manifestQuantity'}
                merchandiseId={merchandiseId}
                warningValue={manifestQuantityQuantity}
              /> */}
                </Grid.Column>
                { (!isTarget || hsDataDtl?.unit2) &&  <Grid.Column
                  className={
                    !commodityHTSOrPrimaryCommodity ? "hide-element" : ""
                  }
                >
                
                  <SelecTextField
                      disableWasChanged={true}
                      isLabel={false}
                      divClassName="secColn"
                      inputName={`${lineItemIndex}${index}additionalQuantity.quantity`}
                      disabled={
                        this.props.enableLineItem === true
                          ? false
                          : isDisabled("dutyItem")
                      }
                      selectName="grossWeight.weightUnits"
                      type="text"
                      label={isTarget ? "CBP QTY 2" : "ADD NET QTY"}
                      dropdownDirectionParam={'center'}
                      id={"additionalQuantity"+merchandiseId+merchandiseDutyId}
                      width="16"
                      textfieldSize={16}
                      className="field-bg"
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      errors={(() => {
                    let myErrorList = [];
                    if(this.getValidationBasedOnHts(additionalQuantityUnits ,additionalQuantityQuantity  ,"ADD NET QTY" ).length > 0 ){
                      myErrorList = myErrorList.concat(
                        this.getValidationBasedOnHts(additionalQuantityUnits ,additionalQuantityQuantity ,"ADD NET QTY")
                      );
                    }
                    myErrorList=myErrorList.concat(
                      fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${"additionalQuantity"}${merchandiseDutyId}`
                      ]||[])
                    return myErrorList;
                  })()}
                      options={unitList}
                      isInteger={true}
                      value={additionalQuantityQuantity}
                      dropDownValue={additionalQuantityUnits}
                      updateValue={(value) => {
                        if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                          this.props.updateFormState("additionalQuantity.quantity", value, "merchandiseDuties.duties", index)
                          return;
                        }
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "additionalQuantity",
                          "quantity",
                          value.replace(/[^\d.-]/g, "")
                        );
                    
                      }}
                      updateDropDownValue={(value) => {
                        if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                          this.props.updateFormState("additionalQuantity.units", value, "merchandiseDuties.duties", index)
                          return;
                        }
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "additionalQuantity",
                          "units",
                          value
                        );
                      
                      }}
                      onBlur={(value) => {
                        if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                          return;
                        }
                        updateMerchDutyItemObject(
                          lineItemIndex,
                          invoiceItemIndex,
                          index,
                          "additionalQuantity",
                          "quantity",
                          parseFloat(additionalQuantityQuantity || 0).toFixed(2)
                        );

                        clearTimeout(window.GLOBAL_additionalquantitiytimeout);
                        window.GLOBAL_additionalquantitiytimeout = setTimeout(
                          () => {
                            saveMerchDutyItem(
                              lineItemIndex,
                              invoiceItemIndex,
                              index,
                              "additionalQuantity"
                            );
                          },
                          400
                        );
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                </Grid.Column>}
              </>
            )}
          {isSteelAluminiumHts && 
            !isCommodityDutyBoolean &&
            <Grid.Column className={"no-field-margin"}>
              <SelecTextField
                isLabel={false}
                dropdownDirectionParam={'center'}
                divClassName="secColn left-border-bottom"
                inputName={`${lineItemIndex}${index}manifestQuantity.weight`}
                ignoreTabOnInputField={true}
                errors={(() => {
              let myErrorList = [];
          
        
              if (
                fieldValidation?.validObjects_bl[
                  `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                ]
              ) {
                myErrorList = myErrorList.concat(
                  fieldValidation?.validObjects_bl[
                    `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                  ]
                );
              }
              if(this.getValidationBasedOnHts(manifestQuantityUnits,manifestQuantityQuantity ,"NET QTY-HTS UNIT" ).length > 0 ){
                myErrorList = myErrorList.concat(
                  this.getValidationBasedOnHts(manifestQuantityUnits,manifestQuantityQuantity ,"NET QTY-HTS UNIT")
                );
              }

              return myErrorList;
            })()}
                // errors={
                //   fieldValidation.validObjects_bl[
                //     `Merchandiseqwqr${"manifestQuantity"}${merchandiseDutyId}`
                //   ]||this.state.hasAdditionalUOMFValidation
                // }
                disabled={
                  this.props.enableLineItem === true
                    ? false
                    : isDisabled("dutyItem")
                }
                selectName="grossWeight.weightUnits"
                type="text"
                id={"grossWeight.weightUnits"+merchandiseId+merchandiseDutyId}
                label={isTarget ? "CBP QTY 1" : "NET QTY-HTS UNIT"}
                width={"16"}
                textfieldSize={16}
                className="field-bg"
                handleFocus={(e) => {
                  e.target.select();
                }}
                options={unitList}
                value={manifestQuantityQuantity}
                isInteger={true}
                dropDownValue={manifestQuantityUnits}
                updateValue={(value) => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    manifestQuantity.quantity = value;
                    this.props.updateFormState("manifestQuantity", manifestQuantity, "merchandiseDuties.duties", index)
                    return;
                  }
                  updateMerchDutyItemObject(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "manifestQuantity",
                    "quantity",
                    value.replace(/[^\d.-]/g, "")
                  );
            
                }}
                updateDropDownValue={(value) => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    manifestQuantity.units = value;
                    this.props.updateFormState("manifestQuantity.units", manifestQuantity, "merchandiseDuties.duties", index)
                    return;
                  }
                  updateMerchDutyItemObject(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "manifestQuantity",
                    "units",
                    value
                  );
                  document.getElementById("VALIDATE_FORM_BUTTON") &&
                    document.getElementById("VALIDATE_FORM_BUTTON").click();

              
                }}
                onBlur={(value) => {
                  if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                    return;
                  }
                  updateMerchDutyItemObject(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "manifestQuantity",
                    "quantity",
                    parseFloat(manifestQuantityQuantity || 0).toFixed(2)
                  );
            
                  saveMerchDutyItem(
                    lineItemIndex,
                    invoiceItemIndex,
                    index,
                    "manifestQuantity"
                  );
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
              </Grid.Column>
            }
            {
              <Grid.Column
                className={"no-field-margin"}
                style={
                  (showFrightData === false || is9802Hts) && !isTotalAdditionDeduction
                    ? { display: "none" }
                    : { display: "block" }
                }
              >
                <InputField
                  subLabelText="$"
                  subLabelClass="left-icon"
                  id={`${lineItemIndex}${index}adjustedValue`}
                  type={"text"}
                  className={"field-bg"}
                  label={"ENTERED VALUE"}
                  saveOnTabOut={true}
                  errors={
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${"adjustedValue"}${merchandiseDutyId}`
                    ]
                  }
                  value={
                    !commodityHTSOrPrimaryCommodity
                      ? adjustedValueZeroIndex === -1 ||
                        adjustedValueZeroIndex === -999
                        ? "0.00"
                        : parseFloat(adjustedValueZeroIndex || 0.0).toFixed(
                            2
                          ) || "0.00"
                      : adjustedValue === -999 ||
                        adjustedValue === -1 ||
                        adjustedValueZeroIndex === -999
                      ? "0.00"
                      : parseFloat(adjustedValue || 0.0).toFixed(2) || "0.00"
                  }
                  handleFocus={(e) => {
                    e.target.select();
                  }}
                  disabled={true}
                  onChange={(value) => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("charges", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "adjustedValue",
                      value.replace(/[^\d.-]/g, "")
                    );
                  }}
                  isInteger={true}
                  onBlur={(value) => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    // Only perform changes if the field was touched (value was edited)
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "adjustedValue",
                      Math.round(parseFloat(value || 0)).toFixed(2)
                    );
                    saveMerchDutyItem(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "adjustedValue"
                    );
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
              </Grid.Column>
            }
            {articleHeader !== "V" && (
              <>
                <Grid.Column className={"no-field-margin"}>
                  <InputField
                    subLabelText="%"
                    subLabelClass="right-icon"
                    id={`${lineItemIndex}${index}dutyRate`}
                    //disabled={this.props.enableLineItem === true ? false : isDisabled('dutyItem')}
                    disabled={true}
                    type={"text"}
                    errors={
                      fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${"dutyRate"}${merchandiseDutyId}`
                      ]
                    }
                    className={"field-bg " +(this.getDutyRate(this.props)||"").split(" ").join("")}//force rerender on duty rate change
                    label={"DUTY RATE"}
                    value={
                     ( ch82BehaviorForChargesAndDuties ) ? "0.00" :
                      dutyRate}
                    labelIcon={
                      <PopUpIcon
                        icon="info circle"
                        popupText={this.getDutyRate(this.props)}
                      />
                    }
                    isInteger={true}
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    onChange={(value) => {
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "dutyRate",
                        value.replace(/[^\d.-]/g, "")
                      );
                    }}
                    onBlur={(value) => {
                      // Update value according to decimal format
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "dutyRate",
                        parseFloat(value || 0).toFixed(2)
                      );
                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "dutyRate"
                      );
                      // updateTotals()
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                </Grid.Column>
                {
                 this.props.launchFrom !== 'PRODUCT_HISTORY' && 
                  <Grid.Column className={"borderEnd no-field-margin duty"}>
                  <InputField
                    subLabelText="$"
                    subLabelClass="left-icon"
                    id={`${lineItemIndex}${index}duty`}
                    disabled={
                      this.props.enableLineItem === true
                        ? false
                        : isDisabled("dutyItem")
                    }
                    type={"text"}
                    className={"field-bg"}
                    errors={
                      fieldValidation?.validObjects_bl[
                        `Merchandiseqwqr${"duty"}${merchandiseDutyId}`
                      ]
                    }
                    label={
                      <>
                        DUTY &nbsp;
                        {(overrideDutyLineItem || (currentMerchandiseDuty.dutyOverrideFlag == 1)) && (
                          <>
                            <input
                              title="OVERRIDE DUTY RATE"
                              className={`dutyxClass${merchandiseId}--dutyoverridecheckbox`}
                              disabled={
                                this.props.enableLineItem ? false : isDisabled("dutyItem")
                              }
                              type="checkbox"
                              id={`${lineItemIndex}${index}dutyOverrideFlag`}
                              onChange={() => {
                                
                                overrideDutyRate(
                                  invoiceItemIndex,
                                  lineItemIndex,
                                  index,currentMerchandiseDuty)
                                  
                              }}
                              checked={
                                currentMerchandiseDuty.dutyOverrideFlag ==
                                1 /*1==true*/
                              }
                            />
                            Override...
                          </>
                        )}
                        {/*end overrideDutyLineItem*/}
                      </>
                    }
                    value={duty}
                    isInteger={true}
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    onChange={(value) => {
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "duty",
                        value.replace(/[^\d.-]/g, "")
                      );
                    }}
                    onBlur={(value) => {
                      // Update value according to decimal format
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        index,
                        "duty",
                        parseFloat(value || 0).toFixed(2)
                      );
                      saveMerchDutyItem(
                        lineItemIndex,
                        invoiceItemIndex,
                        index,
                        "duty"
                      );
                      // updateTotals()
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                </Grid.Column>
                }
              </>
            )}
                        {/*START CHARGESSSSS */}
            {(isCommodityDuty == 1 || (isCommodityHTS && !is9802Hts)) && (
              <Grid.Column className="no-field-margin borderEnd">
                <InputField
                  subLabelText="$"
                  disabled={
                    ch82BehaviorForChargesAndDuties || (
                    this.props.enableLineItem === true
                      ? false
                      : isDisabled("dutyItem"))
                  }
                  subLabelClass="left-icon"
                  id={`${lineItemIndex}-${index}-charges`}
                  labelIcon={
                    <PopUpIcon
                      icon="info circle"
                      popupText={
                        "A minimum of $1 will be enforced for this field due to the EDI requirements set by U.S. Customs and Border Protection."
                      }
                    />
                  }
                  type={"text"}
                  className={"field-bg"}
                  label={"CHARGES"}
                  errors={
                    fieldValidation?.validObjects_bl[
                      `Merchandiseqwqr${"dutyitemcharges"}${merchandiseDutyId}`
                    ]
                  }
                  value={charges}
                  isInteger={true}
                  handleFocus={(e) => {
                    e.target.select();
                  }}
                  onChange={(value) => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("charges", value, "merchandiseDuties.duties", index)
                      return;
                    }
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "charges",
                      value.replace(/[^\d.-]/g, "")
                    );
                  }}
                  onBlur={(value) => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    let newValue = parseFloat(value || 1);
                    // Charges should be a minumum of $1
                    if (newValue < 1) {
                      newValue = 1;
                    }
                    updateMerchDutyItemFeild(
                      invoiceItemIndex,
                      lineItemIndex,
                      index,
                      "charges",
                      Math.round(newValue).toFixed(2)
                    );
                    saveMerchDutyItem(
                      lineItemIndex,
                      invoiceItemIndex,
                      index,
                      "charges"
                    );
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
                {/* <Warning
                    fieldName={'charges'}
                    merchandiseId={merchandiseId}
                    warningValue={charges}
                  /> */}
              </Grid.Column>
            )}
            {/*END CHARGESSSSS */}
          </Grid.Row>
         { isCommodityDuty==1 && <AdditionDeductionMechLevel 
           newValue={newValue}
           fieldName={fieldName}
           setINPUTID={setINPUTID}
           penClicked={penClicked}
           shipmentId={shipmentId}
           rbCounterID={rbCounterID}
           onSave={saveMerchAdditionDeletion} lineItemIndex={lineItemIndex} invoiceItemIndex={invoiceItemIndex} index={index} onUpdate={updateMerchDutyItemObject} className='last-row noTopBorders' disabled={this.props.enableLineItem === true ? false : isDisabled("dutyItem") } />
         }
        </Grid>
         
      </div>
    );
  }
}

// Conponents using controlled Inputs are not allowed to have props of type array or object. For optimization purposes,
// prevProps will be shallow compared to props to detemine update (based on cahnges form other input components that may cause update)
// Props of array or object will !== and cause shouldC
// DutyItem.propTypes = {
//   lineItemIndex: PropTypes.number.isRequired,
//   index: PropTypes.number.isRequired,
//   htsus: PropTypes.string.isRequired,
//   htsDescription: PropTypes.string.isRequired,
//   grossWeightWeight: PropTypes.string.isRequired,
//   grossWeightWeightUnits: PropTypes.string.isRequired,
//   enteredValue: PropTypes.string.isRequired,
//   merchandiseId: PropTypes.string.isRequired,
//   merchandiseDutyId: PropTypes.string.isRequired,
//   manifestQuantityQuantity: PropTypes.string.isRequired,
//   manifestQuantityUnits: PropTypes.string.isRequired,
//   additionalQuantityQuantity: PropTypes.string.isRequired,
//   additionalQuantityUnits: PropTypes.string.isRequired,
//   duty: PropTypes.string.isRequired,
//   dutyRate: PropTypes.string.isRequired,
//   isCommodityDuty: PropTypes.number.isRequired,
//   unitList: PropTypes.array.isRequired,
//   // newValue: ,
//   // fieldName: ,
//   // setINPUTID: ,
//   // penClicked: ,
//   // rbCounterID: PropTypes.string.isRequired,
//   shipmentId: PropTypes.string.isRequired,
//   footnote: PropTypes.string.isRequired,
//   // formDisabled: PropTypes.bool.isRequired
// }

const mapStateToProps = (state, props) => {
  if(props.launchFrom === 'PRODUCT_HISTORY'){
    return ({

    }) 
  }
  return ({
    invoiceItemIndex: props.invoiceItemIndex,
    lineItemIndex: props.lineItemIndex,
    index: props.index,
    invoiceItem : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex],
    invoiceId: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex]['invoiceId'],
    merchandiseLineItem: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex]?.merchandiseLineItems[props.lineItemIndex],
    countryOfOrigin: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]['countryOfOrigin'],
    hsDataDtl: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[props.index].hsDataDtl,
    useAggregated: state.DescriptionOfMerchandise?.useAggregated,
    htsus:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].htsus,
    htsDescription:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].htsDescription,
    categoryCode:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].categoryCode ,
    grossWeightWeight:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .grossWeight.weight,
    grossWeightWeightUnits:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .grossWeight.weightUnits,
    invoiceCurrencyValue:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].invoiceCurrencyValue || 0.00,
    charges:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].charges,
    unitPrice: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
    .merchandiseDuties[props.index].unitPrice,
    enteredValueZeroIndex://Only 01-97 HTS codes get entered values
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[0].enteredValue,
    currentEnteredValuex:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].enteredValue,
    allDuties: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
    .merchandiseDuties,   
    adjustedValue:
    state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
      .merchandiseDuties[props.index].adjustedValue, 
    adjustedValueZeroIndex:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[0].adjustedValue, 
    merchandiseId:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseId,
        displayErrorForEnteredValue:  state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].displayErrorForEnteredValue,
    merchandiseDutyId:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].merchandiseDutyId,
    manifestQuantityQuantity:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].manifestQuantity.quantity,
    invoiceQuantity:
        state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
          .merchandiseDuties[props.index]?.invoiceQuantity?.quantity,
    manifestQuantityUnits:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].manifestQuantity.units,
    invoiceQuantityUnits:
        state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
          .merchandiseDuties[props.index]?.invoiceQuantity?.units,
    additionalQuantityQuantity:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].additionalQuantity.quantity,
    additionalQuantityUnits:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].additionalQuantity.units,
    duty:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].duty,
    dutyRate:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex]?.merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].dutyRate,
    dutyOverrideFlag:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].dutyOverrideFlag,
    currentMerchandiseDuty:
        state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
          .merchandiseDuties[props.index],
    specificRate:
    state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
    .merchandiseDuties[props.index].specificRate, 
    otherRate:
    state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
    .merchandiseDuties[props.index].otherRate, 
    isCommodityDuty:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index].isCommodityDuty,
    adcvd:
        state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
          .merchandiseDuties[props.index].adcvd,     
          
      fieldValidation: state.FieldValidation,
    unitList: state.DropDownValues.unitList||[],
    newValue: state.FormValues.newValue,
    fieldName: state.FormValues.fieldName,
    setINPUTID: state.FormValues.setINPUTID,
    penClicked: state.FormValues.penClicked,
    shipmentId: state.FormValues.shipmentId,
    rbCounterID: state.FormValues.rbCounterID,
    EntryTypeInfo: state.EntryTypeInfo,
    footnote:
      state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .merchandiseDuties[props.index]?.hsDataDtl?.footnote || '',
   
    pgaFlagInfos:
    state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
        .pgaFlagInfos || [],   
    formDisabled: state.FormValues.formDisabled,
    pscData: state.PSC,
    itDate: state.BOLInfo?.itDate?.epochs, 
    entryDate: state.EntryTypeInfo?.summaryDate?.epochs,
    importerAdditionalDeclarationDetails:
      state.DescriptionOfMerchandise.entrySummaryInvoices[
        props.invoiceItemIndex
      ].merchandiseLineItems[props.lineItemIndex]
        .importerAdditionalDeclarationDetails, 
      hsDataDtlForThisDuty:  state.DescriptionOfMerchandise.entrySummaryInvoices[
          props.invoiceItemIndex
        ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[props.index]
          .hsDataDtl,
          totalAdditions:  state.DescriptionOfMerchandise.entrySummaryInvoices[
          props.invoiceItemIndex
        ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[props.index]
          .additions?.totalAdditions,
           totalDeletions:  state.DescriptionOfMerchandise.entrySummaryInvoices[
          props.invoiceItemIndex
        ].merchandiseLineItems[props.lineItemIndex].merchandiseDuties[props.index]
          .deletions?.totalDeletions
            
  })
}

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DutyItem)
